import React, { useState, useEffect, useRef, useCallback, Fragment, useMemo } from 'react';
import axios from 'axios';
import {
    BFILE_API_URL,
    OLD_BFILE_API_URL,
    NEW_BFILES_FS_RS_API_URL,
    RS_DEDICATED_AGENCIES_API_URL,
    VONBOARDER_AGENCIES_API_URL,
    GET_AM_ASSOCIATED_AGENCIES,
    GET_AM_DASH_ACTIVE_CALLS_GRID,
    GET_AM_DASH_ASSETS_UNCOVERED_GRID,
    GET_AM_DASH_COMPLETED_GRID,
    GET_AM_DASH_CUSTOMER_UPLOADED_GRID,
    GET_AM_DASH_FOLLOWUP_GRID,
    GET_AM_DASH_LIFE_OPPORTUNITIES_GRID,
    GET_AM_DASH_NON_RESPONSIVE_GRID,
    GET_AM_DASH_NOT_INTERESTED_GRID,
    GET_AM_DASH_POLICIES_UNCOVERED_GRID,
    GET_AM_DASH_RETIREMENT_UNCOVERED_GRID,
    GET_AM_DASH_SAVE_FOR_LATER_GRID,
    GET_AM_DASH_SCHEDULED_ACTIVITIES_GRID,
    GET_AM_DASH_TOTAL_CUSTOMER_UPLOADED_GRID,
    GET_AM_DASH_BAD_PHONE_NUMBER_GRID,
    GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE,
    GET_GLOBAL_DASH_ACTIVE_CALLS_GRID,
    GET_GLOBAL_DASH_ASSETS_UNCOVERED_GRID,
    GET_GLOBAL_DASH_BAD_PHONE_NUMBER_GRID,
    GET_GLOBAL_DASH_COMPLETED_GRID,
    GET_GLOBAL_DASH_CUSTOMER_UPLOADED_GRID,
    GET_GLOBAL_DASH_EXTERNAL_RAC_BFILE_GRID,
    GET_GLOBAL_DASH_LIFE_OPPORTUNITIES_GRID,
    GET_GLOBAL_DASH_NON_RESPONSIVE_GRID,
    GET_GLOBAL_DASH_NOT_INTERESTED_GRID,
    GET_GLOBAL_DASH_POLICIES_UNCOVERED_GRID,
    GET_GLOBAL_DASH_RETIREMENT_UNCOVERED_GRID,
    GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_GRID,
    GET_GLOBAL_DASH_UMBRELLA_UNCOVERED_GRID,
    RS_DEDICATED_AGENCIES_API_URL_V2,
    GET_RS_USER_AGENCIES,
    GET_AM_UMBRELLA_UNCOVERED_GRID,
    GET_ALL_BFILES,
    GET_ROLES_API,
    GET_AM_AO_AS_EXTERNAL_RAC_BFILE_GRIDS,
    GET_AM_AO_AS_EXTERNAL_RAC_BFILE_GRID,
    GET_AM_AO_AS_EXTERNAL_RAC_LIVE_GRID,
    DOWNLOAD_PHONE_NUMBER_REPORT,
    DOWNLOAD_BAD_PHONE_NUMBER_REPORT,
    COMBINED_COMPLETED_RAC_GRID
} from '../../utils/Api_enums';
import F from "../../Functions";
import moment from 'moment';
import { AGENCY_MANAGER, API_DATE_FORMAT, BAD_PHONE_NUMBER, CARD_HISTORY_TYPE, DATE_FORMAT, EA, END_DATE, EXPORT_DATA, EXPORT_EXCEL, EXTERNAL, EXTERNAL_RAC_COMPLETED_BY_CLIENT, INTERNAL, LSP, NO_DATA_FOUND, PHONE_NUMBER_COPIED_TO_CLIPBOARD, PROSPECT, REVIEW_SCHEDULER, REVIEWSCHEDULER, START_DATE, SUPER_ADMIN, TYPE_OF_CALL, VONBOARDER, VONSCHEDULER } from '../../utils/Constants';
import { Button, Card, Checkbox, Col, DatePicker, Dropdown, Icon, Input, Menu, Pagination, Row, Select, Spin, Tooltip, message, } from 'antd';
import { Translate, Translator } from 'react-translated';
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import ActionMenu from '../LandingPage/menu';
import TransferBfile from "./parts/transfer-bfile-modal";
import ChangeCreator from "./parts/change-creator-modal";
import { debounce } from 'lodash';
import CustomHeader from '../../CommonHeader/CustomHeader';
import Filters from "./filters";
import './callpage.css'
import { useBoundStore } from '../../store/useBoundStore';
import BadNumberTooltip from '../../Custom-Tooltip/BadNumberTooltip';
import CommonHeader from '../Dashboard/CommonHeader';
import Cookies from "js-cookie";
import { useRangePickerCloseButton } from '../../utils/rangePickerCloseButton';


const Option = Select.Option;


const CallPageNew = ({ match, location, auth, history }) => {
    const [open, setOpen] = useState(false);

    const { fSfilters, setFsFilters, resetFsFilters } = useBoundStore((state) => ({
        fSfilters: state.fSfilters,
        setFsFilters: state.setFsFilters,
        resetFsFilters: state.resetFsFilters
    }));

    const { AMDashboardFilter, setAMDashboardFilter, AgencyInfo } = useBoundStore();
    const [roles, setRoles] = useState(JSON.parse(localStorage.getItem('roles')));

    const { RSFSCardFilters, setRSFSCardFilters } = useBoundStore((state) => ({
        RSFSCardFilters: state.RSFSCardFilters,
        setRSFSCardFilters: state.setRSFSCardFilters
    }))

    const [user, setUser] = useState(auth.user);
    const [state, setState] = useState({
        user: null,
        user_t: localStorage.getItem('user_t'),
        agency: "",
        search: "",
        start_date: moment().startOf("month"),
        end_date: moment(),
    });
    const [gridApiOptions, setGridApiOptions] = useState({
        api: null,
        columnApi: null,
    });

    const [user_type, setUserType] = useState(auth.user.user_type);
    const selectedRoleFilter = useBoundStore.getState().RSFSCardFilters.selectedToggle;
    const today = new Date();
    const [searchText, setSearchText] = useState(fSfilters.searchText);

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [selectedCheckboxIds, setSelectedCheckboxIds] = useState([]);
    const [loading, setLoading] = useState(true);
    // const [userT, setUserT] = useState(localStorage.getItem('user_t'));
    const [callpage, setCallpage] = useState("mtd");
    const [title, setTitle] = useState(
        Filters[match.params.filter] && Filters[match.params.filter].title
            ? Filters[match.params.filter].title
            : "B Files"
    );

    const [showHistoryButton, setShowHistoryButton] = useState(false);
    const [path, setPath] = useState(location.pathname);
    const [startDate, setStartDate] = useState(new Date(today.getFullYear(), today.getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date(today.getFullYear(), today.getMonth() + 1, 1));
    const [bfiles, setBfiles] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
    const [isChangeCreatorModalOpen, setIsChangeCreatorModalOpen] = useState(false);
    const [selectedBfiles, setSelectedBfiles] = useState([]);
    const [selectedPageAndBFileIDs, setSelectedPageAndBFileIDs] = useState({});
    const [windowHeight, setWindowHeight] = useState(window.innerHeight - 350);
    const [page, setPage] = useState(AMDashboardFilter.page);
    const [totalPages, setTotalPages] = useState(1);
    const [rowData, setRowData] = useState([]);
    const [sortOrders, setSortOrders] = useState({});
    const [filters, setFilters] = useState("");
    const [endpoint, setEndpoint] = useState(BFILE_API_URL);
    const [columns, setColumns] = useState(null);
    const [orderBy, setOrderBy] = useState(null);
    const [dateRange, setDateRange] = useState(true);
    const [search, setSearch] = useState("");
    const [agencies, setAgencies] = useState([]);
    const [agency, setAgency] = useState("");
    const [setupAppointmentModal, setSetupAppointmentModal] = useState(false);
    const [bfile, setBfile] = useState(null);
    const [transferBfileModal, setTransferBfileModal] = useState(false);
    const [changeCreatorModal, setChangeCreatorModal] = useState(false);
    const [orderBySort, setOrderBySort] = useState(null);
    const [badPhone, setBadPhone] = useState([]);
    const [currentPage, setCurrentPage] = useState(fSfilters.page);
    const pageSize = 10;
    const gridRef = useRef();
    const [selectedAgency, setSelectedAgency] = useState(fSfilters.selectedAgency);
    const initialGlobalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const [globalGridAgencies, setGlobalGridAgencies] = useState([]);
    const [globalGridFilteredAgencyResults, setGlobalGridFilteredAgencyResults] = useState([]);
    const [globalGridAgencyOptions, setGlobalGridAgencyOptions] = useState([]);
    const [gridSelectedCarriers, setGridSelectedCarriers] = useState(
        fSfilters.gridSelectedCarriers && fSfilters.gridSelectedCarriers.length > 0
            ? fSfilters.gridSelectedCarriers
            : (initialGlobalDashboardFilter.selectedCarriers || [])
    );
    const [gridSelectedAgencyState, setGridSelectedAgencyState] = useState(
        fSfilters.gridSelectedAgencyState && fSfilters.gridSelectedAgencyState.length > 0
            ? fSfilters.gridSelectedAgencyState
            : (initialGlobalDashboardFilter.selectedAgencyState || [])
    );
    const [gridSelectedAgencies, setGridSelectedAgencies] = useState(
        fSfilters.gridSelectedAgencies && fSfilters.gridSelectedAgencies.length > 0
            ? fSfilters.gridSelectedAgencies
            : ((initialGlobalDashboardFilter.selectedAgencies && initialGlobalDashboardFilter.selectedAgencies.length > 0)
                ? initialGlobalDashboardFilter.selectedAgencies
                : (initialGlobalDashboardFilter.agency_id ? [initialGlobalDashboardFilter.agency_id] : []))
    );


    const queryParams = new URLSearchParams(location.search);
    const selected_card_type = decodeURIComponent(queryParams.get("selected_card_type"));
    const [selectedCardType, setSelectedCardType] = useState(selected_card_type);


    const [dataReceived, setDataReceived] = useState(false);
    const [gridReady, setGridReady] = useState(false);
    const isGridDestroyed = useRef(false);
    const initializedRef = useRef(false);

    const setSelectedAgencyUndefined = () => {
        if (location.search == '' && location.pathname == "/bfiles") {
            if (selectedAgency == '') {
                setSelectedAgency(undefined);
            }
        }

    }


    useEffect(() => {
        setSelectedAgencyUndefined();
    }, [])

    useEffect(() => {
        if (user_type == AGENCY_MANAGER) {
            setFsFilters({ selectedAgency: AMDashboardFilter.agency_id })
            setSelectedAgency(AMDashboardFilter.agency_id);
        }
    }, [AMDashboardFilter])

    useEffect(() => {
        return () => {
            isGridDestroyed.current = true;
            if (gridApi) {
                setGridApi(null);
                setGridReady(false);
            }
        };
    }, []);

    /**
     * Memoized function to reset all states to their initial values
     * This function is optimized to prevent unnecessary recreations
     * and ensures all state updates happen in a single batch
     * @returns {Promise} Resolves when all states have been reset
     */
    const resetToInitialState = useCallback(() => {
        // Define initial date range for the filters
        // const initialDateRange = {
        //     start_date: "2010-01-01",
        //     end_date: "2050-01-01",
        // };

        return new Promise((resolve) => {
            // Reset all states in sequence

            // resetFsFilters();
            // setdatemodified(initialDateRange);
            setSelectedAgency(undefined);
            setSelectedRole("");
            setSearchText("");
            setTitle(Filters[match.params.filter] && Filters[match.params.filter].title
                ? Filters[match.params.filter].title
                : "B Files");
            setSelectedCardType('');
            resolve();
        });
    }, [match.params.filter, resetFsFilters]);

    /**
     * Effect hook to handle route changes and reset states
     * Implements debouncing to prevent rapid consecutive API calls
     * Ensures cleanup on component unmount
     */
    useEffect(() => {
        // Store current path and search to avoid stale closures
        const currentPath = location.pathname;
        const currentSearch = location.search;

        if (searchText.length > 0) {
            // setFsFilters({ page: 1 }); // commented as its affect when click on any other count
            // debouncedLoadCalls(searchText); //commented as its affect when click on any other count
            return;
        }
        // else if (selectedAgency) {
        //     loadCalls({ pageNumber: page, selectedAgency: selectedAgency });
        // }
        else {
            // loadCalls({ pageNumber: page })
        }

        /**
         * Handles the route change logic
         * - Resets states when navigating to /bfiles
         * - Makes API call only if still on /bfiles after state reset
         * - Manages loading state and error handling
         */
        const handleRouteChange = async () => {
            if (currentPath === "/bfiles" && !currentSearch) {
                setLoading(true);
                try {
                    // Reset all states first
                    await resetToInitialState();

                    // Double check if we're still on /bfiles before API call
                    // Prevents unnecessary API calls during rapid navigation
                    if (currentPath === "/bfiles" && !currentSearch) {
                        await loadCalls();
                    }
                } catch (error) {
                    console.error('Error handling route change:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        // Create debounced version of route change handler
        // 300ms delay prevents excessive calls during rapid route changes
        const debouncedRouteChange = debounce(handleRouteChange, 300);
        debouncedRouteChange();

        // Cleanup function to cancel any pending debounced calls
        // Prevents memory leaks and unnecessary API calls
        return () => {
            debouncedRouteChange.cancel();
        };
    }, [location.pathname, resetToInitialState, searchText]);




    const apiMapAgencyManager = {
        'bad-phone-numbers': GET_AM_DASH_BAD_PHONE_NUMBER_GRID,
        'review-scheduler-calls-made': GET_AM_DASH_CUSTOMER_UPLOADED_GRID,
        'review-scheduler-appointments-scheduled': GET_AM_DASH_SCHEDULED_ACTIVITIES_GRID,
        'review-scheduler-non-responsive': GET_AM_DASH_NON_RESPONSIVE_GRID,
        'review-scheduler-not-interested': GET_AM_DASH_NOT_INTERESTED_GRID,
        'von-calls-made': GET_AM_DASH_CUSTOMER_UPLOADED_GRID,
        'vo-sent-to-financial': GET_AM_DASH_SCHEDULED_ACTIVITIES_GRID,
        'vo-not-reached': GET_AM_DASH_ACTIVE_CALLS_GRID,
        'review-scheduler-not-reached': GET_AM_DASH_ACTIVE_CALLS_GRID,
        'vo-non-responsive': GET_AM_DASH_NON_RESPONSIVE_GRID,
        'vo-not-interested': GET_AM_DASH_NOT_INTERESTED_GRID,
        'cross-sell-policies-uncovered': GET_AM_DASH_POLICIES_UNCOVERED_GRID,
        'sent-to-vonboarder': GET_AM_DASH_FOLLOWUP_GRID,
        'saved_for_later': GET_AM_DASH_SAVE_FOR_LATER_GRID,
        'umbrella-uncovered': GET_AM_UMBRELLA_UNCOVERED_GRID,
        'life-opportunities': GET_AM_DASH_LIFE_OPPORTUNITIES_GRID,
        'retirement-uncovered': GET_AM_DASH_RETIREMENT_UNCOVERED_GRID,
        'total-assets-uncovered': GET_AM_DASH_ASSETS_UNCOVERED_GRID,
        'total-bfiles-sent': GET_AM_DASH_COMPLETED_GRID,
        'total_customer_uploaded': GET_AM_DASH_TOTAL_CUSTOMER_UPLOADED_GRID,
        'von-calls-uploaded': GET_AM_DASH_TOTAL_CUSTOMER_UPLOADED_GRID,
        'externally-completed-bfiles': GET_AM_AO_AS_EXTERNAL_RAC_LIVE_GRID,
        'intelligence-link-completed': COMBINED_COMPLETED_RAC_GRID
    };

    const apiMapGlobalDashboard = {
        'bad-phone-numbers': GET_GLOBAL_DASH_BAD_PHONE_NUMBER_GRID,
        'review-scheduler-calls-made': GET_GLOBAL_DASH_CUSTOMER_UPLOADED_GRID,
        'review-scheduler-appointments-scheduled': GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_GRID,
        'review-scheduler-non-responsive': GET_GLOBAL_DASH_NON_RESPONSIVE_GRID,
        'review-scheduler-not-interested': GET_GLOBAL_DASH_NOT_INTERESTED_GRID,
        'von-calls-made': GET_GLOBAL_DASH_CUSTOMER_UPLOADED_GRID,
        'vo-sent-to-financial': GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_GRID,
        'vo-not-reached': GET_GLOBAL_DASH_ACTIVE_CALLS_GRID,
        'review-scheduler-not-reached': GET_GLOBAL_DASH_ACTIVE_CALLS_GRID,
        'vo-non-responsive': GET_GLOBAL_DASH_NON_RESPONSIVE_GRID,
        'vo-not-interested': GET_GLOBAL_DASH_NOT_INTERESTED_GRID,
        'cross-sell-policies-uncovered': GET_GLOBAL_DASH_POLICIES_UNCOVERED_GRID,
        'umbrella-uncovered': GET_GLOBAL_DASH_UMBRELLA_UNCOVERED_GRID,
        'life-opportunities': GET_GLOBAL_DASH_LIFE_OPPORTUNITIES_GRID,
        'retirement-uncovered': GET_GLOBAL_DASH_RETIREMENT_UNCOVERED_GRID,
        'total-assets-uncovered': GET_GLOBAL_DASH_ASSETS_UNCOVERED_GRID,
        'total-bfiles-sent': GET_GLOBAL_DASH_COMPLETED_GRID,
        'total_customer_uploaded': GET_GLOBAL_DASH_CUSTOMER_UPLOADED_GRID,
        'von-calls-uploaded': GET_GLOBAL_DASH_CUSTOMER_UPLOADED_GRID,
        'externally-completed-bfiles': GET_GLOBAL_DASH_EXTERNAL_RAC_BFILE_GRID,
        'intelligence-link-completed': COMBINED_COMPLETED_RAC_GRID
    };



    const shouldShowHistoryButton = (selectedCardType) => {
        return ['upload', 'scheduling-activity', 'not-interested', 'completed',
            'externally-completed-bfiles', 'intelligence-link-completed'
        ].includes(selectedCardType);
    };


    const getSelectedDate = (location, agenciesList) => {
        console.log(AMDashboardFilter.datemodified);
        const { start_date, end_date } = F.getDefaultDateRange();
        const oldestAgency = F.getOldestAgency(agenciesList && agenciesList.length > 0 ? agenciesList : agencies);
        let result;
        const queryParams = new URLSearchParams(location.search);
        const allBfiles = queryParams.has("all_bfiles");
        const hasDates = queryParams.has("dates");
        const hasCallType = queryParams.has("call_type");
        const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};

        if (user_type === SUPER_ADMIN) {
            if (hasCallType && !allBfiles && !hasDates) {
                const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
                const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
                return { start_date: startOfMonth, end_date: endOfMonth };
            }

            const globalDates = globalDashboardFilter.datemodified || {};
            const fsDates = (useBoundStore.getState().fSfilters || {}).datemodified || {};
            const shouldUseFsDatesForRiskAssessment =
                hasDates &&
                [
                    "/newbfiles/cross-sell-policies-uncovered",
                    "/newbfiles/umbrella-uncovered",
                    "/newbfiles/life-opportunities",
                    "/newbfiles/retirement-uncovered",
                    "/newbfiles/total-assets-uncovered",
                    "/newbfiles/externally-completed-bfiles",
                    "/newbfiles/intelligence-link-completed",
                    "/newbfiles/total-bfiles-sent",

                ].includes(location.pathname) &&
                fsDates.start_date &&
                fsDates.end_date;

            if (shouldUseFsDatesForRiskAssessment) {
                return {
                    start_date: moment(fsDates.start_date).format("YYYY-MM-DD"),
                    end_date: moment(fsDates.end_date).format("YYYY-MM-DD")
                };
            }

            const dateObj = localStorage.getItem("dateObj");

            if (globalDates.start_date && globalDates.end_date) {
                return {
                    start_date: moment(globalDates.start_date).format("YYYY-MM-DD"),
                    end_date: moment(globalDates.end_date).format("YYYY-MM-DD")
                };
            }

            if (dateObj) {
                const parsedDateObj = JSON.parse(dateObj);
                return {
                    start_date: moment(parsedDateObj.start_date).format("YYYY-MM-DD"),
                    end_date: moment(parsedDateObj.end_date).format("YYYY-MM-DD")
                };
            }
        }

        if (location.search == '' && (location.pathname == "/bfiles")) {
            result = {
                start_date: start_date,
                end_date: end_date
            };
        }
        else if (allBfiles) {
            if (location.pathname == "/newbfiles/bad-phone-numbers" && allBfiles) {
                result = {
                    start_date: AMDashboardFilter.datemodified &&
                        AMDashboardFilter.datemodified.start_date ?
                        AMDashboardFilter.datemodified.start_date : start_date,
                    end_date: AMDashboardFilter.datemodified &&
                        AMDashboardFilter.datemodified.end_date ?
                        AMDashboardFilter.datemodified.end_date : end_date
                }
            } else {
                // result = {
                //     start_date: moment('2010-01-01').format(dateFormatYYYY),
                //     end_date: moment('2050-01-01').format(dateFormatYYYY),
                // }
                result = {
                    start_date: AMDashboardFilter.datemodified &&
                        AMDashboardFilter.datemodified.start_date ?
                        AMDashboardFilter.datemodified.start_date : '2010-01-01',
                    end_date: AMDashboardFilter.datemodified &&
                        AMDashboardFilter.datemodified.end_date ?
                        AMDashboardFilter.datemodified.end_date : '2050-01-01'
                }
            }
        } else if (hasDates) {
            //has dates mean
            const dateObjRecentExtRaC = localStorage.getItem("dateObjRecentExtRaC");
            if (dateObjRecentExtRaC) {
                const parsedDateObj = JSON.parse(dateObjRecentExtRaC);
                const startDate = parsedDateObj.start_date ? moment(parsedDateObj.start_date).format(dateFormatYYYY) : null;
                const endDate = parsedDateObj.end_date ? moment(parsedDateObj.end_date).format(dateFormatYYYY) : null;
                result = {
                    start_date: startDate,
                    end_date: endDate
                }
            } else if (user_type == AGENCY_MANAGER) {
                if (AMDashboardFilter.agency_id) {
                    const savedDateObjAgencySelectionAM = JSON.parse(localStorage.getItem('dateObjAgencySelectionAM') || '{}');
                    result = {
                        start_date: (savedDateObjAgencySelectionAM && savedDateObjAgencySelectionAM.start_date) ||
                            (AMDashboardFilter.datemodified &&
                                AMDashboardFilter.datemodified.start_date ?
                                AMDashboardFilter.datemodified.start_date : oldestAgency && oldestAgency.start_date),
                        end_date: (savedDateObjAgencySelectionAM && savedDateObjAgencySelectionAM.end_date) ||
                            (AMDashboardFilter.datemodified &&
                                AMDashboardFilter.datemodified.end_date ?
                                AMDashboardFilter.datemodified.end_date : oldestAgency && oldestAgency.end_date)
                    }

                } else {
                    result = {
                        start_date: oldestAgency && oldestAgency.start_date,
                        end_date: oldestAgency && oldestAgency.end_date
                    }
                }

            } else {
                result = {
                    start_date: start_date,
                    end_date: end_date
                }

            }


        } else {
            if (hasCallType && !allBfiles && !hasDates) {
                const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
                const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
                result = { start_date: startOfMonth, end_date: endOfMonth };
            }
            // else if (user_type == EA && location.search == '' &&
            // (location.pathname == "/bfiles")) {

            //     result = {
            //         start_date: start_date,
            //         end_date: end_date
            //     };

            // }
            else {
                result = {
                    start_date: '2020-01-01',
                    end_date: '2050-01-01'
                };
            }
        }


        console.log(AMDashboardFilter.datemodified);
        console.log("FINAL DATE:", result.start_date, result.end_date);

        return result;

    };



    // Initialize from URL-driven selection to avoid stale persisted dates
    const initialDateRange = getSelectedDate(location);
    const [datemodified, setdatemodified] = useState(initialDateRange);
    const dateFormat = "MM-DD-YYYY";
    const dateFormatYYYY = 'YYYY-MM-DD'
    const [showRoleDropDrown, setShowRoleDropDown] = useState(false);


    const [filterOptions, setFilterOptions] = useState([
        { id: 1, key: "", value: "All B Files" },
        { id: 2, key: "Prospect", value: "Leads" },
        { id: 3, key: "FollowUp", value: "Opportunities" }
    ]);

    const [selectedRole, setSelectedRole] = useState(fSfilters.selectedRole);

    const openTransferModal = () => {
        if (selectedCheckboxIds.length === 0) return;
        setIsTransferModalOpen(true);
    };


    const getCurrentUserRoles = () => {
        try {
            setLoading(true);
            setDataReceived(false);

            const roles = JSON.parse(localStorage.getItem("roles")) || [];


            if (RSFSCardFilters.selectedToggle === VONBOARDER || user.user_type === VONBOARDER) {
                if (roles.includes("Prospect") && roles.includes("FollowUp")) {
                    setShowRoleDropDown(true);
                } else {
                    setShowRoleDropDown(false);
                }
            } else {
                setShowRoleDropDown(false);
            }
        } catch (error) {
            console.log("Error parsing roles from localStorage:", error);
        } finally {
            setDataReceived(true);
            setLoading(false);
        }
    };

    useEffect(() => {
        getCurrentUserRoles();
    }, [RSFSCardFilters.selectedToggle, user.user_type])

    // Ensure store reflects initial date range immediately on mount
    useEffect(() => {
        setFsFilters({ datemodified: initialDateRange, page: 1 });
    }, []);

    useRangePickerCloseButton(open, setOpen);


    const handleRangeChange = (dates) => {
        const start = dates && dates[0]
            ? moment(dates[0]).format("YYYY-MM-DD")
            : null;

        const end = dates && dates[1]
            ? moment(dates[1]).format("YYYY-MM-DD")
            : null;

        setCurrentPage(1);

        setdatemodified((prev) => {

            const updatedStartDate = start;
            const updatedEndDate = end;

            setFsFilters({
                datemodified: {
                    start_date: updatedStartDate,
                    end_date: updatedEndDate,
                },
                page: 1
            });
            if (user.user_type === SUPER_ADMIN) {
                useBoundStore.getState().setGlobalDashboardFilter({
                    datemodified: {
                        start_date: updatedStartDate,
                        end_date: updatedEndDate,
                    },
                    page: 1,
                    isDateRangeClicked: true
                });
            } else {
                setAMDashboardFilter({
                    datemodified: {
                        start_date: updatedStartDate,
                        end_date: updatedEndDate,
                    },
                    isDateRangeClicked: true
                });
            }


            if (updatedStartDate && updatedEndDate) {
                loadCalls();
            }

            return {
                ...prev,
                start_date: updatedStartDate,
                end_date: updatedEndDate,
            };
        });
    };


    const handleDateChange = (date, dateType) => {
        const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;

        setCurrentPage(1);

        setdatemodified((prev) => {
            const updatedStartDate = dateType === "start_date" ? formattedDate : prev.start_date;
            const updatedEndDate = dateType === "end_date" ? formattedDate : prev.end_date;

            setFsFilters({
                datemodified: {
                    start_date: updatedStartDate,
                    end_date: updatedEndDate,
                },
                page: 1
            });
            if (user.user_type === SUPER_ADMIN) {
                useBoundStore.getState().setGlobalDashboardFilter({
                    datemodified: {
                        start_date: updatedStartDate,
                        end_date: updatedEndDate,
                    },
                    page: 1,
                    isDateRangeClicked: true
                });
            } else {
                setAMDashboardFilter({
                    datemodified: {
                        start_date: updatedStartDate,
                        end_date: updatedEndDate,
                    },
                    isDateRangeClicked: true
                });
            }


            if (updatedStartDate && updatedEndDate) {
                loadCalls();
            }


            return {
                ...prev,
                start_date: updatedStartDate,
                end_date: updatedEndDate,
            };
        });
    };

    const closeTransferModal = () => {
        setIsTransferModalOpen(false);
        setSelectedBfiles([]);
    };

    const handleSort = (field) => {
        const sortField = field === 'name_or_phone' ? 'first_name' : field;
        setSortOrders((prev) => {
            const currentOrder = prev[sortField] || "asc";
            const newOrder = currentOrder === "asc" ? "desc" : "asc";
            setFsFilters({ field: sortField, direction: newOrder, page: 1 });
            setAMDashboardFilter({ field: sortField, direction: newOrder });
            loadCalls({ sortBy: sortField, orderBy: newOrder });
            return { ...prev, [sortField]: newOrder };
        });
    };


    const openChangeCreatorModal = () => {
        if (selectedCheckboxIds.length === 0) return;
        setIsChangeCreatorModalOpen(true);
    };

    const closeChangeCreatorModal = () => {
        setIsChangeCreatorModalOpen(false);
        setSelectedBfiles([]);
    };


    // Function to fetch RS agencies
    const callRsAgencies = async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(GET_RS_USER_AGENCIES, {
                params: { user_type: REVIEWSCHEDULER },
            });
            setAgencies(data);
            if (Array.isArray(data) && data.length > 0) {
                localStorage.setItem("rs_user_agencies", JSON.stringify(data));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    // Function to fetch VO agencies
    const callVoAgencies = async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(VONBOARDER_AGENCIES_API_URL, {
                params: { user_type: VONBOARDER },
            });
            setAgencies(data)
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    // Function to fetch Review Scheduler  agencies
    const callReviewAgencies = async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(`${RS_DEDICATED_AGENCIES_API_URL_V2}/${user.id}`);
            const modifiedData = data.map(item => ({
                ...item,
                name: item.agency_name,
                id: item.agency_id,

            }));


            setAgencies(modifiedData)
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (RSFSCardFilters.selectedToggle === VONBOARDER) {
            callVoAgencies();
        } else if (RSFSCardFilters.selectedToggle === REVIEWSCHEDULER && user.user_type != AGENCY_MANAGER) {
            callReviewAgencies();
        }
    }, [RSFSCardFilters.selectedToggle])

    //fetch agency manager associated agencies
    const getAssociatedAgencyAM = async () => {
        try {
            const res = await axios.get(`${GET_AM_ASSOCIATED_AGENCIES}/${user.id}`);
            if (res.data && res.data.length > 0) {
                setAgencies(res.data);
                return res.data;
            }
            return [];
        } catch (error) {
            console.error("Error fetching associated agencies:", error);
            return [];
        }
    };




    useEffect(() => {
        setPath(location.pathname);
    }, [location]);


    const [filterColumnField, setFilterColumnField] = useState('');
    const [filterColumnValue, setFilterColumnValue] = useState('');

    const handleFilter = (field, value) => {
        let filterField = field;


        if (field === 'first_name') {
            filterField = 'name_or_phone';
        } else if (field === 'sub_type_of_call') {
            filterField = 'sub_type_of_call_or_call_attempts';
        }


        let filterValue = value;
        if (
            filterField === 'updated_on' &&
            value &&
            typeof value === 'object' &&
            value.start_date &&
            value.end_date
        ) {
            const startDate = moment((value && value.start_date) || '2010-01-01').format('YYYY-MM-DD');
            const endDate = moment((value && value.end_date) || '2050-01-01').format('YYYY-MM-DD');
            filterValue = {
                from: startDate,
                to: endDate,
            };
        }


        setFilterColumnField(filterField);
        setFilterColumnValue(filterValue);
        setCurrentPage(1);


        setFsFilters(
            {
                filter_by_column_name: { [filterField]: filterValue },
                page: 1
            }
        );


        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            loadCalls({ pageNumber: 1 });
        }, 500);
    };

    const fetchFilteredCalls = async ({ pageNumber, selectedAgency, searchByName, sortBy,
        orderBy,
        isExport
    }) => {
        const user_info = JSON.parse(Cookies.get("user_info"));
        let fS = useBoundStore.getState().fSfilters;
        let params = {};
        params.user_id = user_info.id;
        params.agency_id = user_info.agency_id;
        params.from = fS.datemodified.start_date;
        params.to = fS.datemodified.end_date;
        params.page = fS.page;
        if (searchByName) {
            params.search_param = searchByName;
        }
        if (sortBy && orderBy) {
            const sortField = sortBy === 'name_or_phone' ? 'first_name' : sortBy;
            params.order_by = JSON.stringify([{ field: sortField, direction: orderBy }]);
        }
        // if (filterColumnField && filterColumnValue) {
        //     const filterObj = {};
        //     filterObj[filterColumnField] = filterColumnValue;
        //     params.filter_by_column_name = JSON.stringify(filterObj);
        // }
        if (fS.filter_by_column_name &&
            Object.keys(fS.filter_by_column_name).length > 0
            && Object.values(fS.filter_by_column_name).length > 0) {
            params.filter_by_column_name = JSON.stringify(fS.filter_by_column_name);
        }
        if (isExport) {
            params.export = true;
        }

        const queryString = new URLSearchParams(params).toString();
        const url = `${GET_ALL_BFILES}?${queryString}`;
        try {
            let res;

            if (isExport) {
                res = await axios.get(url, {
                    responseType: "blob"
                });
            } else {
                res = await axios.get(url);
            }


            //  EXPORT FLOW
            if (isExport) {
                if (res.data.type === "application/json") {
                    message.error("No data found");
                    return;
                }

                const blob = new Blob([res.data], {
                    type: "text/csv;charset=utf-8;"
                });

                const fileName = `${title} Report_${moment().format("YYYY-MM-DD")}.csv`;

                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = downloadUrl;
                link.setAttribute("download", fileName);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(downloadUrl);

                return;
            }

            if (res.data.objects.length > 0) {
                setRowData(F.convertTypeOfCall(res.data.objects));
                setTotalPages(res.data.total_pages);
            } else {
                setRowData([]);
                setTotalPages(0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setRowData([]);
            setTotalPages(0);
        } finally {
            setLoading(false);
        }
    };

    const getGlobalDashboardAgencyIdsForGrid = () => {
        const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
        const fS = useBoundStore.getState().fSfilters || {};
        const selectedAgencies = fS.gridSelectedAgencies && fS.gridSelectedAgencies.length > 0
            ? fS.gridSelectedAgencies
            : (globalFilter.selectedAgencies || []);
        const filteredAgencyIds = fS.gridFilteredAgencyIds && fS.gridFilteredAgencyIds.length > 0
            ? fS.gridFilteredAgencyIds
            : (globalFilter.filteredAgencyIds || []);
        const selectedCarriers = fS.gridSelectedCarriers && fS.gridSelectedCarriers.length > 0
            ? fS.gridSelectedCarriers
            : (globalFilter.selectedCarriers || []);
        const selectedAgencyState = fS.gridSelectedAgencyState && fS.gridSelectedAgencyState.length > 0
            ? fS.gridSelectedAgencyState
            : (globalFilter.selectedAgencyState || []);
        const hasCarrierOrStateFilter = selectedCarriers.length > 0 || selectedAgencyState.length > 0;

        if (selectedAgencies.length > 0) {
            return selectedAgencies;
        }

        if (globalFilter.agency_id) {
            return [globalFilter.agency_id];
        }

        if (hasCarrierOrStateFilter) {
            return filteredAgencyIds.length > 0 ? filteredAgencyIds : [-1];
        }

        return [];
    };

    const getCarrierFilterValues = (selectedCarriers = gridSelectedCarriers) => {
        return selectedCarriers
            .map((selectedCarrier) => {
                const carrier = F.getCarriers().find((item) => item.id === selectedCarrier);
                return carrier ? carrier.name : selectedCarrier;
            })
            .filter((carrier) => carrier && carrier !== "All Carrier");
    };

    const getLocallyFilteredGlobalAgencies = (
        agenciesList = globalGridAgencies,
        selectedCarriers = gridSelectedCarriers,
        selectedAgencyState = gridSelectedAgencyState
    ) => {
        const carrierFilters = getCarrierFilterValues(selectedCarriers);
        const activeFilters = selectedAgencyState.map(String);

        return agenciesList.filter((agency) => {
            const carrierMatch = carrierFilters.length === 0 || carrierFilters.includes(agency.agency_owner_carrier);
            const activeMatch = activeFilters.length === 0 || activeFilters.includes(String(agency.active === 1));

            return carrierMatch && activeMatch;
        });
    };

    const getInitialGlobalAgencyOptions = (agenciesList, selectedAgencies = gridSelectedAgencies) => {
        const selectedIds = new Set(selectedAgencies || []);
        const selectedAgencyOptions = agenciesList.filter((agency) => selectedIds.has(agency.id));
        const firstAgencies = agenciesList.slice(0, 100);
        const optionMap = new Map();

        [...selectedAgencyOptions, ...firstAgencies].forEach((agency) => {
            optionMap.set(agency.id, agency);
        });

        return Array.from(optionMap.values());
    };

    const getGlobalAgencyDateRange = (selectedAgencyIds, agenciesList) => {
        const selectedIds = new Set(selectedAgencyIds || []);
        const selectedAgencyList = agenciesList.filter((agency) => selectedIds.has(agency.id));
        const oldestAgency = F.getOldestAgency(selectedAgencyList.length > 0 ? selectedAgencyList : agenciesList);

        if (!oldestAgency) {
            return {
                start_date: moment().startOf("month").format("YYYY-MM-DD"),
                end_date: moment().endOf("month").format("YYYY-MM-DD")
            };
        }

        const startDate = moment(oldestAgency.start_date);
        const endDate = moment(oldestAgency.end_date || new Date());

        return {
            start_date: startDate.isValid() ? startDate.format("YYYY-MM-DD") : START_DATE,
            end_date: endDate.isValid() ? endDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
        };
    };

    const applyGlobalGridAgencyFilters = ({
        selectedCarriers = gridSelectedCarriers,
        selectedAgencyState = gridSelectedAgencyState,
        selectedAgencies = gridSelectedAgencies,
        agenciesList = globalGridAgencies,
        dateRangeOverride = null,
        shouldLoad = true
    } = {}) => {
        const filteredAgencyResults = getLocallyFilteredGlobalAgencies(agenciesList, selectedCarriers, selectedAgencyState);
        const validSelectedAgencies = (selectedAgencies || []).filter((agencyId) =>
            filteredAgencyResults.some((agency) => agency.id === agencyId)
        );
        const filteredAgencyIds = filteredAgencyResults.map((agency) => agency.id).filter(Boolean);
        const hasCarrierOrStateFilter = selectedCarriers.length > 0 || selectedAgencyState.length > 0;
        const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
        const globalDates = globalFilter.datemodified || {};
        const fsDates = (useBoundStore.getState().fSfilters || {}).datemodified || {};
        const queryParams = new URLSearchParams(location.search);
        const shouldUseFsDatesForRiskAssessment =
            queryParams.has("dates") &&
            [
                "/newbfiles/cross-sell-policies-uncovered",
                "/newbfiles/umbrella-uncovered",
                "/newbfiles/life-opportunities",
                "/newbfiles/retirement-uncovered",
                "/newbfiles/total-assets-uncovered",
                "/newbfiles/externally-completed-bfiles",
                "/newbfiles/intelligence-link-completed",
                "/newbfiles/total-bfiles-sent"
            ].includes(location.pathname) &&
            fsDates.start_date &&
            fsDates.end_date;
        const shouldUseGlobalDashboardDates =
            globalFilter.isDateRangeClicked &&
            globalDates.start_date &&
            globalDates.end_date;
        const hasNoPageGridFilters = selectedCarriers.length === 0 &&
            selectedAgencyState.length === 0 &&
            validSelectedAgencies.length === 0;
        const updatedDateRange = dateRangeOverride || (shouldUseFsDatesForRiskAssessment
            ? {
                start_date: moment(fsDates.start_date).format("YYYY-MM-DD"),
                end_date: moment(fsDates.end_date).format("YYYY-MM-DD")
            }
            : ((shouldUseGlobalDashboardDates || hasNoPageGridFilters) && globalDates.start_date && globalDates.end_date
            ? {
                start_date: moment(globalDates.start_date).format("YYYY-MM-DD"),
                end_date: moment(globalDates.end_date).format("YYYY-MM-DD")
            }
            : getGlobalAgencyDateRange(validSelectedAgencies, filteredAgencyResults)));

        setGlobalGridFilteredAgencyResults(filteredAgencyResults);
        setGlobalGridAgencyOptions(getInitialGlobalAgencyOptions(filteredAgencyResults, validSelectedAgencies));
        setGridSelectedCarriers(selectedCarriers);
        setGridSelectedAgencyState(selectedAgencyState);
        setGridSelectedAgencies(validSelectedAgencies);
        setdatemodified(updatedDateRange);
        setCurrentPage(1);
        setPage(1);

        setFsFilters({
            gridSelectedCarriers: selectedCarriers,
            gridSelectedAgencyState: selectedAgencyState,
            gridSelectedAgencies: validSelectedAgencies,
            gridFilteredAgencyIds: hasCarrierOrStateFilter
                ? (filteredAgencyIds.length > 0 ? filteredAgencyIds : [-1])
                : [],
            datemodified: updatedDateRange,
            page: 1
        });

        if (shouldLoad) {
            loadCalls({ pageNumber: 1 });
        }
    };

    useEffect(() => {
        if (user.user_type !== SUPER_ADMIN) return undefined;

        let isMounted = true;
        const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
        const fsFilter = useBoundStore.getState().fSfilters || {};
        const selectedCarriers = fsFilter.gridSelectedCarriers && fsFilter.gridSelectedCarriers.length > 0
            ? fsFilter.gridSelectedCarriers
            : (globalFilter.selectedCarriers || []);
        const selectedAgencyState = fsFilter.gridSelectedAgencyState && fsFilter.gridSelectedAgencyState.length > 0
            ? fsFilter.gridSelectedAgencyState
            : (globalFilter.selectedAgencyState || []);
        const selectedAgencies = fsFilter.gridSelectedAgencies && fsFilter.gridSelectedAgencies.length > 0
            ? fsFilter.gridSelectedAgencies
            : ((globalFilter.selectedAgencies && globalFilter.selectedAgencies.length > 0)
                ? globalFilter.selectedAgencies
                : (globalFilter.agency_id ? [globalFilter.agency_id] : []));
        const queryParams = new URLSearchParams(location.search);
        const dateRangeOverride = queryParams.has("call_type") &&
            !queryParams.has("all_bfiles") &&
            !queryParams.has("dates")
            ? {
                start_date: moment().startOf("month").format("YYYY-MM-DD"),
                end_date: moment().endOf("month").format("YYYY-MM-DD")
            }
            : null;

        axios.get(GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE)
            .then((res) => {
                if (!isMounted) return;
                const agenciesList = Array.isArray(res.data) ? res.data : [];
                setGlobalGridAgencies(agenciesList);
                applyGlobalGridAgencyFilters({
                    selectedCarriers,
                    selectedAgencyState,
                    selectedAgencies,
                    agenciesList,
                    dateRangeOverride,
                    shouldLoad: false
                });
            })
            .catch((error) => {
                console.error("Error fetching global grid agencies:", error);
                if (!isMounted) return;
                setGlobalGridAgencies([]);
                setGlobalGridFilteredAgencyResults([]);
                setGlobalGridAgencyOptions([]);
            });

        return () => {
            isMounted = false;
            setFsFilters({
                gridSelectedCarriers: [],
                gridSelectedAgencyState: [],
                gridSelectedAgencies: [],
                gridFilteredAgencyIds: [],
            });
        };
    }, [user.user_type]);

    const getGlobalDashboardGridDateRange = () => {
        const queryParams = new URLSearchParams(location.search);
        const isMonthlyCountRoute = queryParams.has("call_type") &&
            !queryParams.has("all_bfiles") &&
            !queryParams.has("dates");

        if (isMonthlyCountRoute) {
            return {
                start_date: moment().startOf("month").format('YYYY-MM-DD'),
                end_date: moment().endOf("month").format('YYYY-MM-DD')
            };
        }

        const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
        const globalDates = globalFilter.datemodified || {};
        const fS = useBoundStore.getState().fSfilters;
        const dateObj = localStorage.getItem("dateObj");

        const hasGlobalDates = globalDates.start_date && globalDates.end_date;
        const hasFsDates = fS.datemodified && fS.datemodified.start_date && fS.datemodified.end_date;
        const shouldUseFsDatesForRiskAssessment =
            queryParams.has("dates") &&
            [
                "/newbfiles/cross-sell-policies-uncovered",
                "/newbfiles/umbrella-uncovered",
                "/newbfiles/life-opportunities",
                "/newbfiles/retirement-uncovered",
                "/newbfiles/total-assets-uncovered",
                "/newbfiles/externally-completed-bfiles",
                "/newbfiles/intelligence-link-completed",
                "/newbfiles/total-bfiles-sent"
            ].includes(location.pathname) &&
            hasFsDates;
        const hasDefaultFsDates = hasFsDates &&
            moment(fS.datemodified.start_date).format('YYYY-MM-DD') === START_DATE &&
            moment(fS.datemodified.end_date).format('YYYY-MM-DD') === END_DATE;

        if (shouldUseFsDatesForRiskAssessment) {
            return {
                start_date: moment(fS.datemodified.start_date).format('YYYY-MM-DD'),
                end_date: moment(fS.datemodified.end_date).format('YYYY-MM-DD')
            };
        }

        if (hasGlobalDates && hasDefaultFsDates) {
            return {
                start_date: moment(globalDates.start_date).format('YYYY-MM-DD'),
                end_date: moment(globalDates.end_date).format('YYYY-MM-DD')
            };
        }

        if (hasFsDates) {
            return {
                start_date: moment(fS.datemodified.start_date).format('YYYY-MM-DD'),
                end_date: moment(fS.datemodified.end_date).format('YYYY-MM-DD')
            };
        }

        if (hasGlobalDates) {
            return {
                start_date: moment(globalDates.start_date).format('YYYY-MM-DD'),
                end_date: moment(globalDates.end_date).format('YYYY-MM-DD')
            };
        }

        if (dateObj) {
            const parsedDateObj = JSON.parse(dateObj);
            return {
                start_date: moment(parsedDateObj.start_date).format('YYYY-MM-DD'),
                end_date: moment(parsedDateObj.end_date).format('YYYY-MM-DD')
            };
        }

        return {
            start_date: moment(START_DATE).format('YYYY-MM-DD'),
            end_date: moment(END_DATE).format('YYYY-MM-DD')
        };
    };

    const fetchDataForGlobalDashboard = async ({ api, isExport } = {}) => {
        setLoading(true);

        const fS = useBoundStore.getState().fSfilters;
        const { start_date, end_date } = getGlobalDashboardGridDateRange();
        const payload = {
            agency_ids: getGlobalDashboardAgencyIdsForGrid(),
            start_date,
            end_date,
            page: fS.page
        };

        if (getCallType(location)) {
            payload.type_of_call = getCallType(location);
        }

        if (fS.searchText) {
            payload.search = fS.searchText;
        }

        if (fS.field && fS.direction) {
            const sortField = fS.field === 'name_or_phone' ? 'first_name' : fS.field;
            payload.sort = `${sortField}:${fS.direction}`;
        }

        if (fS.filter_by_column_name &&
            Object.keys(fS.filter_by_column_name).length > 0) {
            payload.filter_by_column_name = fS.filter_by_column_name;
        }

        if (isExport) {
            payload.export = true;
        }

        try {
            let res;
            if (api === COMBINED_COMPLETED_RAC_GRID) {
                const combinedParams = new URLSearchParams({
                    start_date: payload.start_date,
                    end_date: payload.end_date,
                    page: payload.page,
                    per_page: 10,
                });
                if (payload.agency_ids.length === 1) {
                    combinedParams.set("agency_id", payload.agency_ids[0]);
                } else if (payload.agency_ids.length > 1) {
                    combinedParams.set("agency_ids", payload.agency_ids.join(","));
                }
                if (payload.search) combinedParams.set("search", payload.search);
                if (payload.sort) combinedParams.set("sort", payload.sort);
                if (payload.filter_by_column_name) {
                    combinedParams.set("filter_by_column_name", JSON.stringify(payload.filter_by_column_name));
                }
                if (payload.export) combinedParams.set("export", true);
                res = await axios.get(
                    `${api}?${combinedParams.toString()}`,
                    isExport ? { responseType: "blob" } : undefined
                );
            } else {
                res = await axios.post(api, payload, isExport ? { responseType: "blob" } : undefined);
            }

            if (isExport) {
                if (res.data.type === "application/json") {
                    message.error("No data found");
                    return;
                }

                const blob = new Blob([res.data], {
                    type: "text/csv;charset=utf-8;"
                });
                const fileName = `${title} Report_${moment().format("YYYY-MM-DD")}.csv`;
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = downloadUrl;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
                return;
            }

            if (isGridDestroyed.current) return;

            if (res.data.data && res.data.data.length > 0) {
                setRowData(res.data.data);
                setTotalPages(res.data.total_pages);
                safeSetRowData(res.data.data);
            } else {
                setRowData([]);
                setTotalPages(0);
            }
        } catch (error) {
            console.error("Error fetching global dashboard grid data:", error);
            message.error("Error fetching data");
        } finally {
            setDataReceived(true);
            setLoading(false);
        }
    };


    const fetchDataForAM = async ({ api, isExport } = {}) => {
        if (user.user_type === SUPER_ADMIN) {
            await fetchDataForGlobalDashboard({ api, isExport });
            return;
        }

        setLoading(true);

        let params = {};
        const fS = useBoundStore.getState().fSfilters;

        const dateObj = localStorage.getItem("dateObj");
        const queryParams = new URLSearchParams(location.search);
        const hasDates = queryParams.has("dates");
        const hasCallType = queryParams.has("call_type");
        const allBfiles = queryParams.has("all_bfiles");

        if (hasDates || allBfiles) {
            if (fS.datemodified.start_date) params.start_date = moment(fS.datemodified.start_date).format('YYYY-MM-DD');
            if (fS.datemodified.end_date) params.end_date = moment(fS.datemodified.end_date).format('YYYY-MM-DD');
        } else if (dateObj) {
            const parsedDateObj = JSON.parse(dateObj);
            params.start_date = moment(parsedDateObj.start_date).format('YYYY-MM-DD');
            params.end_date = moment(parsedDateObj.end_date).format('YYYY-MM-DD');

        } else if (hasCallType && !allBfiles && !hasDates) {
            params.start_date = moment().startOf("month").format("YYYY-MM-DD");
            params.end_date = moment().endOf("month").format("YYYY-MM-DD");
        }
        else {
            params.start_date = moment('2010-01-01').format('YYYY-MM-DD');
            params.end_date = moment('2050-01-01').format('YYYY-MM-DD');
        }

        // am_customer_uploaded_grid + all_bfiles: use 2050-01-01 end_date until user picks a range.
        // Date picker still shows AMDashboardFilter dates via getSelectedDate / datemodified state.
        const amFilter = useBoundStore.getState().AMDashboardFilter || {};
        if (
            api === GET_AM_DASH_CUSTOMER_UPLOADED_GRID &&
            allBfiles &&
            !amFilter.isDateRangeClicked
        ) {
            params.end_date = END_DATE;
        }





        params.page = fS.page;
        if (api === COMBINED_COMPLETED_RAC_GRID) {
            params.per_page = 10;
            const combinedAgencyId = fS.selectedAgency || user.agency_id;
            if (combinedAgencyId) params.agency_id = combinedAgencyId;
        }

        if (getCallType(location)) {
            params.type_of_call = getCallType(location);
        }

        if (fS.selectedAgency) params.agency_id = fS.selectedAgency;
        if (fS.searchText) params.search = fS.searchText;

        if (fS.field && fS.direction) {
            const sortField = fS.field === 'name_or_phone' ? 'first_name' : fS.field;
            params.sort = `${sortField}:${fS.direction}`;
        }

        let userId = localStorage.getItem('user_t');
        if (userId && userId != 'all' && api != GET_AM_DASH_BAD_PHONE_NUMBER_GRID) {
            params.bfile_user_id = userId;
        }

        if (fS.filter_by_column_name &&
            Object.keys(fS.filter_by_column_name).length > 0) {
            params.filter_by_column_name = JSON.stringify(fS.filter_by_column_name);
        }

        if (isExport) {
            params.export = true;
        }

        const queryString = new URLSearchParams(params).toString();
        const url = `${api}?${queryString}`;

        try {

            let res;
            if (isExport) {
                res = await axios.get(url, {
                    responseType: "blob"
                });
            } else {
                res = await axios.get(url);
            }
            //  EXPORT FLOW
            if (isExport) {
                if (res.data.type === "application/json") {
                    message.error("No data found");
                    return;
                }

                const blob = new Blob([res.data], {
                    type: "text/csv;charset=utf-8;"
                });

                const fileName = `${title} Report_${moment().format("YYYY-MM-DD")}.csv`;

                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = downloadUrl;
                link.setAttribute("download", fileName);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(downloadUrl);

                return;
            }

            // NORMAL FLOW
            if (isGridDestroyed.current) return;

            if (res.data.data && res.data.data.length > 0) {
                setRowData(res.data.data);
                setTotalPages(res.data.total_pages);
                safeSetRowData(res.data.data);
            } else {
                setRowData([]);
                setTotalPages(0);
            }

        } catch (error) {
            console.error("Error fetching data:", error);

            // handle blob error
            if (isExport && error.response && error.response.data && error.response.data instanceof Blob) {
                const errorText = await error.response.data.text();
                try {
                    const errorJson = JSON.parse(errorText);
                    message.error(errorJson.message || "Error downloading report");
                } catch (err) {
                    message.error("Error downloading report");
                }
            } else {
                message.error("Error fetching data");
            }

        } finally {
            setDataReceived(true);
            setLoading(false);
        }
    };

    const updateFilters = () => {
        let { start_date, end_date, agency, search, user_t } = state;
        const today = moment(new Date()).format(API_DATE_FORMAT);
        let title = "B Files";
        let filters = "";
        let callpage = "bfiles";
        let endpoint = OLD_BFILE_API_URL;
        let columns = null;
        let order_by = null;
        let date_range = true;

        const fS = useBoundStore.getState().fSfilters;
        const from = fS.datemodified.start_date;
        const to = fS.datemodified.end_date;

        const queryParams = new URLSearchParams(location.search);
        const call_type = decodeURIComponent(queryParams.get("call_type")) || null;

        if (match.params.filter !== undefined) {
            callpage = match.params.filter;
            const f = Filters[match.params.filter];
            if (f) {
                title = f.title || "B Files";
                filters = f.filters || filters;
                endpoint = f.endpoint || endpoint;
                columns = f.columns || columns;
                order_by = f.order_by || order_by;
                date_range = f.date_range !== undefined ? f.date_range : true;
            }
        } else {
            date_range = false;
        }

        if (agency) {
            if (filters) filters += ",";
            filters += `{"name":"agency_id","op":"==","val":"${agency}"}`;
        }

        if (call_type && call_type !== "null" && call_type !== null && call_type !== "" && callpage !== "bad-phone-numbers") {

            if (filters !== "") filters = filters + ",";
            if (call_type !== PROSPECT) {
                filters =
                    filters +
                    '{"or":[{"name":"type_of_call","op":"is_null"},{"name":"type_of_call","op":"==","val":"' +
                    call_type +
                    '"}]}';
            }
            else {
                filters =
                    filters +
                    '{"name":"type_of_call","op":"==","val":"' +
                    call_type +
                    '"}';
            }
        }

        if (user_t && user_t !== null && user_t !== "" && callpage !== "bad-phone-numbers") {

            if (filters !== "") filters = filters + ",";
            filters =
                filters +
                '{"name":"user_id","op":"==","val":"' +
                user_t +
                '"}';
        }

        const searchPurify = F.removeSpecialCharactersFromString(fS.searchText || searchText || "");
        if (searchPurify) {
            const queries = [
                // "first_name",
                // "last_name",
                // "spouse_first_name",
                // "spouse_last_name",
                "email",
                "phone",
            ].flatMap(field => [
                { name: field, op: "like", val: `%${searchPurify}%` },
            ]);

            const search_arr = [...new Set(searchPurify.split(" "))];
            search_arr.forEach(word => {
                if (word) {
                    ["first_name", "last_name", "spouse_first_name", "spouse_last_name"].forEach(field => {
                        queries.push({ name: field, op: "like", val: `%${word}%` });
                    });
                }
            });


            if (filters) filters += ",";
            filters += `{"or":${JSON.stringify(queries)}}`;
        }

        if (callpage === "saved_for_later" && callpage !== "bfiles") {
            if (filters) filters += ",";
            filters += `{"name":"is_saved_for_later","op":"==","val":"1"}`;
        }

        if (callpage === "vo-sent-to-financial") {
            if (filters) filters += ",";
            filters += `{"or":[{"and":[{"name":"rs_scheduled_date","op":">=","val":"%from%"},{"name":"rs_scheduled_date","op":"<","val":"%to%"}]},{"and":[{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}]}]},{"name": "vob_completed","op": "==","val": "1"},{"name":"vob_archived","op":"is_null"}`;
        }


        if (
            callpage !== "deleted" &&
            callpage !== "archived" &&
            callpage !== "renewals" &&
            callpage !== "review-scheduler-not-interested" &&
            filters.indexOf("archive") < 0 &&
            callpage !== "vo-sent-to-financial" && // new condition added
            callpage !== "vo-not-reached" &&
            callpage !== "review-scheduler-non-responsive" &&// new condition added for non responsive mig
            callpage !== "vo-non-responsive" // new condition added for non responsive mig
        ) {
            if (filters !== "") filters = filters + ",";
            filters = filters + '{"name":"archive","op":"==","val":"0"},{"name":"non_responsive","op":"==","val":"0"}';

        }

        if (["vo-not-reached"].includes(callpage)) {
            if (filters) filters += ",";
            filters += `{"or":[{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]},{"and":[{"name":"bfile_sub","op":"any","val":{"name":"not_reached_date","op":">=","val":"%from%"}},{"name":"bfile_sub","op":"any","val":{"name":"not_reached_date","op":"<=","val":"%to%"}}]}]}`;
        }

        if (["vo-not-interested"].includes(callpage)) {
            if (filters) filters += ",";
            filters += `{"or":[{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]},{"and":[{"name":"bfile_sub","op":"any","val":{"name":"not_interested_date","op":">=","val":"%from%"}},{"name":"bfile_sub","op":"any","val":{"name":"not_interested_date","op":"<=","val":"%to%"}}]}]}`;
        }

        if (callpage.includes("rs-")) {
            if (filters) filters += ",";
            filters += `{"or":[{"and":[{"name":"rs_date","op":">=","val":"%from%"},{"name":"rs_date","op":"<","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}`;
        }




        const is_all_bfiles = false;

        if (!is_all_bfiles) {
            if (callpage === "review-scheduler-bfiles") {
                if (filters !== "") filters = filters + ",";
                filters =
                    filters +
                    '{"name":"rs_appointment_date","op":">=","val":"%from%"},{"name":"rs_appointment_date","op":"<","val":"%to%"}';
            } else if (callpage === "user-rs-appointments-scheduled") {
                if (filters !== "") filters = filters + ",";
                filters =
                    filters +
                    '{"name":"rs_date","op":">=","val":"%from%"},{"name":"rs_date","op":"<","val":"%to%"}';
            } else if (
                callpage === "review-scheduler-calls-made" ||
                callpage === "von-calls-made"
                || callpage === "von-calls-uploaded"
            ) {
                if (filters !== "") filters = filters + ",";

                filters += JSON.stringify({
                    and: [
                        // { name: "created_on", op: ">=", val: from },
                        // { name: "created_on", op: "<=", val: to }
                        { name: "reuploaded_on", op: ">=", val: "%from%" },
                        { name: "reuploaded_on", op: "<=", val: "%to%" }
                    ]
                });
            } else if (callpage === "review-scheduler-not-interested") {
                if (filters !== "") filters = filters + ",";
                filters =
                    filters +
                    '{"or":[{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<","val":"%to%"}]},{"and":[{"name":"bfile_sub","op":"any","val":{"name":"not_interested_date","op":">=","val":"%from%"}},{"name":"bfile_sub","op":"any","val":{"name":"not_interested_date","op":"<=","val":"%to%"}}]}]}';
            } else if (callpage === "review-scheduler-non-responsive") {
                if (filters !== "") filters = filters + ",";
                filters =
                    filters +
                    '{"or":[{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]},{"and":[{"name":"bfile_sub","op":"any","val":{"name":"non_responsive_date","op":">=","val":"%from%"}},{"name":"bfile_sub","op":"any","val":{"name":"non_responsive_date","op":"<=","val":"%to%"}}]}]}';
            } else if (callpage === "review-scheduler-not-reached") {
                if (filters !== "") filters = filters + ",";
                filters =
                    filters +
                    '{"or":[{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]},{"and":[{"name":"bfile_sub","op":"any","val":{"name":"not_reached_date","op":">=","val":"%from%"}},{"name":"bfile_sub","op":"any","val":{"name":"not_reached_date","op":"<=","val":"%to%"}}]}]}';
            } else if (callpage === "review-scheduler-appointments-scheduled") {
                if (filters !== "") filters = filters + ",";
                filters =
                    filters +
                    '{"or":[{"and":[{"name":"rs_scheduled_date","op":">=","val":"%from%"},{"name":"rs_scheduled_date","op":"<","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
            }
            else {
                if (
                    callpage.indexOf("rs-") >= 0 ||
                    callpage.indexOf("review-scheduler-") >= 0
                ) {
                    if (filters !== "") filters = filters + ",";
                    filters =
                        filters +
                        '{"or":[{"and":[{"name":"rs_date","op":">=","val":"%from%"},{"name":"rs_date","op":"<","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
                }
            }


            //second condition for date range
            if (
                callpage !== "onboarding-calls" &&
                callpage !== "financial-intro" &&
                callpage !== "renewal" &&
                callpage !== "renewal-mycalls" &&
                callpage !== "onboarding-calls-attempted"
            ) {
                if (date_range) {
                    if (
                        callpage !== "rs-upcoming-calls" &&
                        callpage !== "sent-to-vonboarder" &&
                        callpage.indexOf("vo-") < 0 &&
                        callpage.indexOf("pending-") < 0 &&
                        callpage !== "renewals" &&
                        callpage !== "onboarding-calls-total" &&
                        callpage.indexOf("rs-") < 0 &&
                        callpage.indexOf("review-scheduler-") < 0 &&
                        callpage !== "virtual-follow-up-due-calls" &&
                        callpage !== "virtual-follow-up-incompleted-calls" &&
                        callpage !== "von-calls-made" &&
                        callpage !== "von-calls-uploaded" &&
                        callpage !== "total-bfiles-sent"
                    ) {
                        if (filters !== "" && title !== "Bad Phone Number")
                            filters = filters + ",";
                        if (title !== "Bad Phone Number") {
                            filters =
                                filters +
                                '{"or":[{"and":[{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
                        }
                    }

                    // if (callpage === "total-bfiles-sent") {
                    //     if (filters !== "" && title !== "Bad Phone Number")
                    //         filters = filters + ",";
                    //     filters =
                    //         filters +
                    //         '{"or":[{"and":[{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}]},{"and":[{"name":"updated_on","op":">=","val":"%from%"},{"name":"updated_on","op":"<=","val":"%to%"}]}{"and":[{"name":"bfile_sub","op":"any","val":{"name":"completed_date","op":">=","val":"%from%"}},{"name":"bfile_sub","op":"any","val":{"name":"completed_date","op":"<=","val":"%to%"}}]}]}';
                    // }
                    // new add
                    ///////////////////////////////////
                    if (
                        (callpage !== "sent-to-vonboarder" &&
                            callpage.indexOf("vo-") >= 0) &&
                        callpage !== "vo-sent-to-financial" &&
                        callpage !== "vo-not-reached" &&
                        callpage !== "vo-non-responsive" &&
                        callpage !== "vo-not-interested"
                    ) {
                        // F.log("filters ==>> 2 ", filters);
                        if (filters !== "" && title !== "Bad Phone Number")
                            filters = filters + ",";
                        if (title !== "Bad Phone Number") {
                            filters =
                                filters +
                                '{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}';
                        }
                    }
                    ///////////////////////////////////
                    if (callpage === "onboarding-calls-total"
                        || callpage === "sent-to-vonboarder") {
                        if (filters !== "") filters = filters + ",";
                        filters =
                            filters +
                            '{"or":[{"and":[{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
                    }
                }
            }
        }

        if (callpage !== "deleted") {
            if (filters !== "") filters = filters + ",";
            filters = filters + '{"name":"deleted","op":"==","val":"0"}';
        }

        if (
            // callpage === "cross-sell-policies-uncovered" &&
            location.state != null &&
            location.state.user_t != null &&
            location.state.user_t != "string"
            // &&
            // this.props.location.state.user_t.trim().length > 0
        ) {
            if (filters !== "") filters = filters + ",";
            // filters = filters + '{"name":"user_id","op":"==","val":"%user_id%"}';
            filters =
                filters +
                '{"name":"user_id","op":"==","val":' +
                `${location.state.user_t}` +
                "}";
        }

        filters = filters.replace(
            /%reviewer_id%/g,
            new URLSearchParams(location.search).get("reviewer_id")
        );

        filters = filters.replace(/%user_id%/g, user.id);
        // filters = filters.replace(/%from%/g, start_date);
        // filters = filters.replace(/%to%/g, end_date);
        filters = filters.replace(/%from%/g, `${from}:00:00:00`);
        filters = filters.replace(/%to%/g, `${to}:23:59:59`);
        filters = filters.replace(/%today%/g, today);

        if (typeof match.params.ea !== "undefined") {
            if (filters !== "") filters = filters + ",";
            filters =
                filters +
                '{"name":"onboarding_id","op":"==","val":"' +
                match.params.ea +
                '"}';
        }
        if (typeof match.params.lsp !== "undefined") {
            if (filters !== "") filters = filters + ",";
            filters =
                filters +
                '{"name":"user_id","op":"==","val":"' +
                match.params.lsp +
                '"}';
        }
        if (typeof match.params.efs !== "undefined") {
            if (filters !== "") filters = filters + ",";
            filters =
                filters +
                '{"name":"financial_id","op":"==","val":"' +
                match.params.efs +
                '"}';
        }

        // new add
        if (title !== "Bad Phone Number" && title !== "Follow-Up") {
            filters = F.getDncFilter(filters);
        }

        return {
            title,
            filters,
            endpoint,
            columns,
            order_by,
            date_range,
            callpage,
            page: 1,
        }

    };


    const safeSetRowData = useCallback((data) => {
        if (gridApi && gridReady && !isGridDestroyed.current) {
            try {
                gridApi.setRowData(data);
            } catch (error) {
                console.warn('Failed to set grid data:', error);
            }
        }
    }, [gridApi, gridReady])


    const fetchDataForEA = async ({
        sortBy = "updated_on",
        orderBy = "desc"
    }) => {
        const filtersRaw = updateFilters().filters;
        const filters = JSON.parse(`[${filtersRaw}]`);
        const endpoint = updateFilters().endpoint;
        const fS = useBoundStore.getState().fSfilters;

        const queryParams = {
            page: fS.page,
            q: JSON.stringify({
                filters: filters,
                order_by: [{ field: sortBy, direction: orderBy }]
            })
        };

        const queryString = new URLSearchParams(queryParams).toString();

        try {
            const res = await axios.get(`${endpoint}?${queryString}`);

            if (isGridDestroyed.current) return;

            if (res.data.objects) {
                console.log(JSON.stringify(res.data.objects[0]))
                safeSetRowData(res.data.objects);

                return {
                    rowData: F.convertTypeOfCall(res.data.objects),
                    totalPages: res.data.total_pages
                };
            }
        } catch (error) {
            console.error("Error fetching data for EA:", error);
        } finally {
            setDataReceived(true);
        }
    };








    const loadCalls = async ({
        pageNumber = 1,
        selectedAgency = false,
        searchByName = false,
        sortBy = "updated_on",
        orderBy = "desc",
        isExport = false
    }

        = {}) => {

        setLoading(true);
        setDataReceived(false);


        const { fSfilters } = useBoundStore.getState();

        setCurrentPage(fSfilters.page);

        const finalSelectedAgency = selectedAgency ? selectedAgency : fSfilters.selectedAgency;
        const finalSearchByName = searchByName ? searchByName : fSfilters.searchText;


        try {
            if (location && location.pathname == "/bfiles") {
                const rsFSCardFilter = useBoundStore.getState().RSFSCardFilters;
                if (user.user_type === REVIEWSCHEDULER || rsFSCardFilter.selectedToggleAPI === REVIEWSCHEDULER) {
                    await callRsAgencies();
                    const storedAgencies = JSON.parse(localStorage.getItem("rs_user_agencies"));
                    if (
                        (user.user_type === REVIEWSCHEDULER && (!storedAgencies || storedAgencies.length === 0)) ||
                        (rsFSCardFilter.selectedToggleAPI === REVIEWSCHEDULER && (!storedAgencies || storedAgencies.length === 0))
                    ) {
                        return;
                    }
                }


                const data = await fetchFilteredCalls({
                    pageNumber: pageNumber,
                    selectedAgency: finalSelectedAgency,
                    searchByName: finalSearchByName,
                    sortBy: sortBy,
                    orderBy: orderBy,
                    isExport: isExport
                });
                if (data && !isGridDestroyed.current) {
                    setRowData(data.rowData);
                    setTotalPages(data.totalPages);
                    safeSetRowData(data.rowData);

                }
            }
            else if (user.user_type === AGENCY_MANAGER
                || user.user_type == EA || user.user_type == LSP
                || user.user_type === SUPER_ADMIN
            ) {
                const api = user.user_type === SUPER_ADMIN
                    ? apiMapGlobalDashboard[match.params.filter]
                    : apiMapAgencyManager[match.params.filter];
                console.log(api)
                if (api) {
                    await fetchDataForAM({ api, isExport });
                }
            }
            // else if (user.user_type == EA || user.user_type == LSP) {
            //     const data = await fetchDataForEA({
            //         pageNumber,
            //         finalSelectedAgency,
            //         finalSearchByName,
            //         sortBy, orderBy
            //     });
            //     if (data) {
            //         setRowData(data.rowData);
            //         setTotalPages(data.totalPages);
            //     }
            // }

            else {
                const data = await fetchFilteredCalls({
                    pageNumber: pageNumber,
                    selectedAgency: finalSelectedAgency,
                    searchByName: finalSearchByName,
                    sortBy: sortBy,
                    orderBy: orderBy,
                    isExport: isExport
                });
                if (data && !isGridDestroyed.current) {
                    setRowData(data.rowData);
                    setTotalPages(data.totalPages);
                    safeSetRowData(data.rowData);

                }
            }
        } catch (error) {
            console.error("Error loading calls:", error);
        } finally {
            setDataReceived(true);
            if (!isGridDestroyed.current) {
                setLoading(false);
            }
        }

    };


    const goTo = (path) => {
        history.push({
            pathname: path,
            state: { ...location.state }
        });
    };




    const CreateNameRenderer = (params) => {
        const bfile = params.data;
        const showBN = params.data.bad_phone_number_status == 1;

        const [menuVisible, setMenuVisible] = useState(false);

        const handleVisibleChange = (flag) => {
            setMenuVisible(flag);
        };


        return (
            <div>
                {/* Name */}
                <div>
                    {(user.user_type === LSP || user.user_type === EA) ? (
                        <div>
                            <ActionMenu
                                bfile={bfile}
                                user={user}
                                history={history}
                                update={(bfile) => loadCalls({ pageNumber: page })}
                                refresh={() => loadCalls({ pageNumber: page })}
                                is_callpage={true}
                                location={location}
                            />
                            {showBN && (<BadNumberTooltip />)}
                        </div>
                    ) : (

                        <div>
                            <Icon type="user" style={{ marginRight: 10, color: '#666' }} />
                            <a className='custom-link'
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    goTo("/customer/" + bfile.id);
                                }}
                            >
                                <span
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: 160,
                                        display: "inline-block"
                                    }}
                                >
                                    {F.stripHtml(`${bfile.first_name || ""} ${bfile.last_name || ""}`.trim())}
                                </span>
                            </a>
                            {showBN && <BadNumberTooltip />}
                        </div>

                    )
                    }
                </div>
                {/* Phone Numbers */}
                <div>
                    {params.data.phone && (
                        <div className="phoneField" style={{ marginTop: '-15px', display: 'flex', alignItems: 'center' }}>
                            <Icon type="phone" style={{ marginRight: 10 }} />
                            <a href={"tel:" + F.phone_format(params.data.phone)}
                                className='phone-link'
                            >
                                {F.phone_format(params.data.phone)}
                            </a>
                            <Tooltip title="Copy phone number">
                                <Icon
                                    type="copy"
                                    style={{ marginLeft: 8, cursor: 'pointer', fontSize: '14px', color: '#1890ff' }}
                                    onClick={() => F.handleCopyClick(params.data.phone)}
                                />
                            </Tooltip>
                        </div>
                    )}
                    {params.data.phone2 && params.data.phone2 !== "" && (
                        <div className="phoneField" style={{ marginTop: '-15px', display: 'flex', alignItems: 'center' }}>
                            <Icon type="phone" style={{ marginRight: 10 }} />
                            <a href={"tel:" + F.phone_format(params.data.phone2)}
                                className='phone-link'>
                                {F.phone_format(params.data.phone2)}
                            </a>
                            <Tooltip title="Copy phone number">
                                <Icon
                                    type="copy"
                                    style={{ marginLeft: 8, cursor: 'pointer', fontSize: '14px', color: '#1890ff' }}
                                    onClick={() => F.handleCopyClick(params.data.phone2)}
                                />
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const getInt = (val) => {
        if (isNaN(parseInt(val))) return 0
        else return parseInt(val)
    }

    const getCallAttempts = (bfile) => {
        switch (user.user_type) {
            case REVIEWSCHEDULER:
                return getInt(bfile.attempts) + getInt(bfile.rs_attempts) || 0;
            case VONBOARDER:
                return getInt(bfile.attempts) + parseInt(F.getCallAttemptsFromBFileQuestionArray(bfile)) || 0;
            case VONSCHEDULER:
                if (selectedRoleFilter === REVIEWSCHEDULER)
                    return getInt(bfile.attempts) + getInt(bfile.rs_attempts) || 0;
                else
                    return getInt(bfile.attempts) + parseInt(F.getCallAttemptsFromBFileQuestionArray(bfile)) || 0;
            default:
                return parseInt(F.getCallAttemptsFromBFileQuestionArray(bfile)) +
                    getInt(bfile.attempts) +
                    getInt(bfile.rs_attempts) || 0;
        }
    }

    const CreateValueRenderer = (params) => {
        const { headers, data } = params;

        return (
            <div>
                {headers.map((header, index) => {
                    let value = data[header];
                    if (data) {
                        if (value && (header == "updated_on" || header == 'last_updated')) {
                            value = moment(data[header]).format("MM/DD/YYYY hh:mmA");
                        } else if (value && header == "expiration_date") {
                            value = moment(data[header]).format("MM/DD/YYYY");
                        } else if (header == "rs_attempts") {
                            if (title === EXTERNAL_RAC_COMPLETED_BY_CLIENT) {
                                value = data.call_attempts || 0;
                            } else {
                                value = getCallAttempts(data)
                            }

                        } else if (header === 'who_reffered' || header === 'referred_by') {
                            value = '-'
                            // value = data.who_reffered || '-';
                        } else if (header === 'who_created') {
                            value = data.who_created || '-';
                        }
                        else if (header === "user.first_name") {
                            value = `${data.user && data.user.first_name || ""} ${data.user && data.user.last_name || ""}`;
                        }
                        else if (header == "referred_by") {
                            value = `${data.referred_by || "-"}`;
                        }
                        else if (header == "life_stage") {
                            value = F.bfile_life_stage(data).title;
                        } else if (header == "retirement_dollars") {
                            value = `$${data.retirement_dollars_calculated &&
                                data.retirement_dollars_calculated.toLocaleString('en-US')}`;
                            // value = F.dollar_format(F.bfile_get_retirement_dollars(data));
                        } else if (header == "priority_status") {
                            value = "Standard";
                        }
                        else if (header == 'ages') {
                            let ages = [];
                            if (data.birthday) {
                                ages.push(F.getAge(F.validDate(data.birthday, "/")));
                            }
                            if (data.spouse_birthday) {
                                ages.push(F.getAge(F.validDate(data.spouse_birthday, "/")));
                            }
                            value = ages.length > 0 ? ages.join("/") : "-";
                        }
                        else if (header == "employment") {
                            value = F.bfile_employment_status(data);
                        } else if ((value == "" || value === undefined || value === null) && header === "sub_type_of_call") {
                            value = '-';
                        } else if (header === "sub_type_of_call") {
                            const items = (value || "").split(",").map(v => v.trim()).filter(Boolean);

                            value = (
                                <div>
                                    {items.map((v, i) => {
                                        if (i % 2 === 0) {
                                            return (
                                                <div key={i}>
                                                    {v}{items[i + 1] ? ", " + items[i + 1] : ""}
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}
                                </div>
                            );
                        }

                        else if (data[header] == 0) {
                            value = data[header];
                        } else if (header == "type_of_call") {
                            value = params.data.type_of_call && F.transformCallTypeLabel(params.data.type_of_call) || "-";
                        }
                        else {
                            value = data[header] || "-";
                        }
                    }
                    else {
                        value = data[header] || "-";
                    }

                    return (
                        <div key={index}>
                            <p style={{ marginTop: index > 0 ? "-25px" : "0px" }}>
                                {value}
                            </p>
                        </div>

                    );
                })}
            </div>
        );
    };



    const columnDefs = useMemo(() => {
        const baseDefs = [
            {
                headerName: "",
                field: "checkbox",
                checkboxSelection: true,
                headerCheckboxSelection: true,
                width: 50,
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Name", "Phone"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "name_or_phone",
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                    // filterValue: filterColumnField === "name_or_phone" ? filterColumnValue : "",
                    // key: filterKey
                }),
                field: "name_or_phone",
                cellRenderer: CreateNameRenderer,
                sortable: true,
                filter: true,
                autoHeight: true,
                autoHeaderHeight: true,
                width: 250
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Ages", "Employment"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "ages",
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler
                }),
                sortable: false,
                filter: true,
                autoHeight: true,
                autoHeaderHeight: true,
                cellRendererParams: { headers: ["ages", "employment"] },
                cellRenderer: CreateValueRenderer,
                pinned: 'left',
                suppressHorizontalScroll: true,
                lockPinned: false,
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Type of Call"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "type_of_call",
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "select",
                    options: F.getTypeOFCallCRM(),
                    handleFilterResetHandler
                }),
                sortable: true,
                filter: true,
                autoHeight: true,
                autoHeaderHeight: true,
                cellRendererParams: { headers: ["type_of_call"] },
                cellRenderer: CreateValueRenderer
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Sub-Type", "# Call Attempts"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "sub_type_of_call",
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler
                }),
                colId: "expiration_date",
                sortable: false,
                filter: true,
                autoHeight: true,
                cellRenderer: CreateValueRenderer,
                cellRendererParams: { headers: ["sub_type_of_call", "rs_attempts"] },
                autoHeaderHeight: true,
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Who Created", "Last Updated", "Who Referred"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "updated_on",
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    renderFilter: ({ filterValue, onFilterChange }) => {
                        const selectedRange = filterValue && filterValue.start_date && filterValue.end_date
                            ? [moment(filterValue.start_date, 'MM-DD-YYYY'), moment(filterValue.end_date, 'MM-DD-YYYY')]
                            : [moment('2010-01-01'), moment('2050-01-01')];

                        return (
                            <div onClick={(event) => event.stopPropagation()}>
                                <DatePicker.RangePicker
                                    getCalendarContainer={() => document.body}
                                    className="custom-datepicker"
                                    dropdownClassName="column-filter-date-picker"
                                    format="MM-DD-YYYY"
                                    value={selectedRange}
                                    onChange={(dates) => {
                                        if (dates && dates.length === 2) {
                                            onFilterChange({
                                                start_date: dates[0].format('MM-DD-YYYY'),
                                                end_date: dates[1].format('MM-DD-YYYY')
                                            });
                                        } else {
                                            onFilterChange(null);
                                        }
                                    }}
                                    renderExtraFooter={() => (
                                        <div
                                            className="column-filter-today"
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                const today = moment().format('MM-DD-YYYY');
                                                onFilterChange({ start_date: today, end_date: today });
                                            }}
                                        >
                                            Today
                                        </div>
                                    )}
                                />
                            </div>
                        );
                    },
                    handleFilterResetHandler
                }),
                sortable: true,
                filter: true,
                autoHeight: true,
                cellRenderer: CreateValueRenderer,
                cellRendererParams: (params) => {
                    const data = params.data || {};
                    const hasWhoCreated = data.who_created;
                    return {
                        headers: hasWhoCreated
                            ? ["who_created", "last_updated", "who_reffered"]
                            : ["user.first_name", "updated_on", "referred_by"]
                    };
                },
                autoHeaderHeight: true
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Life Stage"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "life_stage",
                    handleFilter,
                    showPopOver: true,
                    inputType: "select",
                    options: F.getLifeStage(),
                    handleFilterResetHandler
                }),
                sortable: false,
                filter: true,
                autoHeight: true,
                cellRenderer: CreateValueRenderer,
                cellRendererParams: { headers: ["life_stage"] },
                autoHeaderHeight: true
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Retirement Dollars"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "retirement_dollars",
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler
                }),
                sortable: false,
                filter: true,
                autoHeight: true,
                cellRenderer: CreateValueRenderer,
                cellRendererParams: { headers: ["retirement_dollars"] },
                autoHeaderHeight: true
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["P&C Items", "in Household"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "cross_sell_policies_uncovered",
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler
                }),
                sortable: false,
                filter: true,
                autoHeight: true,
                cellRenderer: CreateValueRenderer,
                cellRendererParams: { headers: ["cross_sell_policies_uncovered"] },
                autoHeaderHeight: true
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Priority Status"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "priority_status",
                    handleFilter,
                    // showPopOver: true,
                    // inputType: "text"
                    handleFilterResetHandler
                }),
                sortable: false,
                filter: true,
                autoHeight: true,
                cellRenderer: CreateValueRenderer,
                cellRendererParams: { headers: ["priority_status"] },
                autoHeaderHeight: true
            },
            {
                headerClass: 'custom-ag-header',
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Status"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "type_of_call",
                    handleFilter,
                    showPopOver: true,
                    inputType: "select",
                    options: F.getTypeOFCallCRM(),
                    handleFilterResetHandler
                }),
                sortable: false,
                filter: true,
                autoHeight: true,
                cellRenderer: CreateValueRenderer,
                cellRendererParams: { headers: ["type_of_call"] },
                autoHeaderHeight: true
            }
        ];
        const linkTypeColumn = {
            headerClass: 'custom-ag-header',
            headerComponent: CustomHeader,
            headerComponentParams: (params) => ({
                headers: ['Link Type'],
                colDef: params.column.getColDef(),
                columnApi: params.columnApi,
                field: 'link_type',
                handleFilter,
                showPopOver: true,
                inputType: 'select',
                options: [
                    { id: INTERNAL, name: INTERNAL },
                    { id: EXTERNAL, name: EXTERNAL }
                ],
                handleFilterResetHandler
            }),
            field: 'link_type',
            minWidth: 130,
            sortable: false,
            filter: true,
            autoHeight: true,
            autoHeaderHeight: true,
            cellRendererFramework: (params) => {
                const value = params.data.isExternal ? EXTERNAL : INTERNAL;
                return <span>{value}</span>;
            }
        };
        const columnsForCard = selectedCardType === CARD_HISTORY_TYPE.INTELLIGENCE_LINK_COMPLETED
            ? baseDefs.concat(linkTypeColumn)
            : baseDefs;
        const filteredColumnsDefs =
            user.user_type === EA || user.user_type === LSP
                ? columnsForCard
                : columnsForCard.filter(col => col.field !== "checkbox");
        return filteredColumnsDefs;
    }, [roles, selectedCardType, user.user_type]);

    useEffect(() => {
        const loadInitialData = async () => {
            setLoading(true);
            try {
                let fetchedAgencies = [];

                // Step 1: Fetch agencies FIRST
                if (user.user_type === "EFS") {
                    const res = await axios.get("/api/my_agencies");
                    fetchedAgencies = res.data;
                    setAgencies(fetchedAgencies);
                }

                if (user.user_type === REVIEWSCHEDULER) {
                    if (localStorage.rs_agency_id) {
                        setAgency(parseInt(localStorage.rs_agency_id));
                    }
                    fetchedAgencies = await callRsAgencies();
                }

                if (user.user_type === VONBOARDER) {
                    if (localStorage.rs_agency_id) {
                        setAgency(parseInt(localStorage.rs_agency_id));
                    }
                    fetchedAgencies = await callVoAgencies();
                }

                if (user.user_type === "EA") {
                    const res = await axios.get(`/api/users/${user.id}`);
                    if (res.data.user_agency_assoc.length > 0) {
                        const agencyId = res.data.user_agency_assoc[0].agency_id || null;
                        setAgency(agencyId);
                    }
                }

                if (user.user_type === AGENCY_MANAGER) {
                    fetchedAgencies = await getAssociatedAgencyAM();
                }

                // Step 2: Compute correct date range with fresh agencies
                const selectedDateRange = getSelectedDate(location, fetchedAgencies);
                setdatemodified(selectedDateRange);
                setFsFilters({
                    datemodified: selectedDateRange,
                    page: 1
                });
                // setAMDashboardFilter({
                //     datemodified: selectedDateRange,
                //     page: 1
                // });

                // Step 3: Load calls with correct dates
                initializedRef.current = true;
                await loadCalls({ pageNumber: 1 });

            } catch (error) {
                console.error("Error loading initial data:", error);
                setRowData([]);
                setTotalPages(0);
            } finally {
                setLoading(false);
            }
        };

        loadInitialData();

        return () => { };
    }, [user.user_type, location.pathname, location.search]);


    useEffect(() => {
        // CLEANUP function runs when the component unmounts
        return () => {
            localStorage.removeItem("dateObjRecentExtRaC");
            console.log("localStorage cleared on unmount dateObjRecentExtRaC");
        };
    }, []);



    useEffect(() => {
        const timeout = setTimeout(() => {
            autoSizeGridColumns();
        }, 0);
        return () => clearTimeout(timeout);
    }, [rowData]);




    const autoSizeGridColumns = () => {
        if (gridApiOptions.columnApi && rowData && rowData.length) {
            const allColumns = gridApiOptions.columnApi.getAllColumns();
            if (allColumns && allColumns.length) {
                const allColumnIds = allColumns
                    .map(col => col.getColId())
                    .filter(id => !['checkbox'].includes(id));
                gridApiOptions.columnApi.autoSizeColumns(allColumnIds, false);
            }
        }
    };


    const handleExportExcel = async () => {


        if (title === BAD_PHONE_NUMBER && user.user_type !== SUPER_ADMIN) {

            const agency_id = useBoundStore.getState().AgencyInfo.id || null;

            const formattedStartDate = moment(datemodified.start_date, "YYYY-MM-DD", true);
            const formattedEndDate = moment(datemodified.end_date, "YYYY-MM-DD", true);

            if (formattedStartDate.isValid() && formattedEndDate.isValid()) {
                if (formattedStartDate.isAfter(formattedEndDate)) {
                    message.destroy();
                    message.error("Start date cannot be greater than the end date.");
                    return;
                }
            }

            const data = {
                start_date: datemodified.start_date,
                end_date: datemodified.end_date,
                agency_id: agency_id
            };

            try {
                setLoading(true);

                const response = await axios.post(`${DOWNLOAD_BAD_PHONE_NUMBER_REPORT}`, data, {
                    responseType: "blob",
                });


                if (response.data.type === "application/json") {
                    message.error(NO_DATA_FOUND);
                    return;
                }


                const fileName = `${BAD_PHONE_NUMBER} report from ${moment(datemodified.start_date).format(DATE_FORMAT)} to ${moment(datemodified.end_date).format(DATE_FORMAT)}.csv`;

                const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error("Error downloading report:", error);

                if (error.response && error.response.data instanceof Blob) {
                    const errorText = await error.response.data.text();
                    try {
                        const errorJson = JSON.parse(errorText);
                        message.destroy();
                        message.error(errorJson.message || errorJson.error || "Error downloading report");
                    } catch (e) {
                        console.error("Raw error text:", errorText);
                        message.error("Error downloading report");
                    }
                } else {
                    message.error(error.message || "Error downloading report");
                }
            } finally {
                setLoading(false);
            }
        }
        else {
            await loadCalls({ isExport: true });
        }
    };


    const exportExcel = () => {
        loadCalls({ isExport: true });
    }



    const refresh = () => {
        resetHandlers.current.forEach(reset => reset());
        setCurrentPage(1);
        //resetFsFilters();
        const selectedDateRange = getSelectedDate(location);
        setdatemodified(selectedDateRange);

        if (location.search == '' && location.pathname == "/bfiles") {
            setSelectedAgency(undefined);
        } else {
            setSelectedAgency("");
        }
        setSelectedRole("");
        setSearchText('');
        setFilterColumnField(''); // Clear funnel filter field
        setFilterColumnValue(''); // Clear funnel filter value
        if (user.user_type === SUPER_ADMIN) {
            const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
            const selectedCarriers = globalFilter.selectedCarriers || [];
            const selectedAgencyState = globalFilter.selectedAgencyState || [];
            const selectedAgencies = globalFilter.selectedAgencies && globalFilter.selectedAgencies.length > 0
                ? globalFilter.selectedAgencies
                : (globalFilter.agency_id ? [globalFilter.agency_id] : []);

            applyGlobalGridAgencyFilters({
                selectedCarriers,
                selectedAgencyState,
                selectedAgencies,
                agenciesList: globalGridAgencies,
                dateRangeOverride: selectedDateRange,
                shouldLoad: true
            });
            setFsFilters({
                field: "",
                direction: "",
                selectedRole: "",
                selectedAgency: "",
                searchText: "",
                datemodified: selectedDateRange,
                filter_by_column_name: {},
            });
            return;
        }
        setFsFilters({
            field: "", direction: "", selectedRole: "", page: 1,
            selectedAgency: "", searchText: "", datemodified: selectedDateRange,
            filter_by_column_name: {}, // Clear funnel filter in store
            gridSelectedCarriers: [],
            gridSelectedAgencyState: [],
            gridSelectedAgencies: [],
            gridFilteredAgencyIds: [],
        });
        loadCalls({ pageNumber: 1 })
    };





    //comm dp impl
    // const selectAgency = (value) => {
    //     setSelectedAgency(value);
    //     setFsFilters({ selectedAgency: value, page: 1 });
    //     loadCalls();
    // }


    const selectAgency = (value) => {
        let startDate = datemodified.start_date;
        let endDate = datemodified.end_date;

        if (value) {
            const selected = agencies.find(a => a.agency_id === value);

            if (selected) {
                startDate = moment(selected.start_date).format("YYYY-MM-DD");
                endDate = moment().format("YYYY-MM-DD");
            }
        }

        const updatedDateRange = {
            start_date: startDate,
            end_date: endDate,
        };

        // set correct updated dates
        setdatemodified(updatedDateRange);

        setSelectedAgency(value);
        setFsFilters({
            selectedAgency: value,
            datemodified: updatedDateRange, //  important (sync store)
            page: 1
        });

        loadCalls();
    };

    const selectGlobalGridAgencies = (selectedAgencies) => {
        applyGlobalGridAgencyFilters({
            selectedAgencies,
            shouldLoad: true
        });
    };

    const searchGlobalGridAgencies = (value) => {
        if (!value) {
            setGlobalGridAgencyOptions(getInitialGlobalAgencyOptions(globalGridFilteredAgencyResults, gridSelectedAgencies));
            return;
        }

        const lower = value.toLowerCase();
        const filtered = globalGridFilteredAgencyResults.filter((agency) =>
            (agency.name || `Agency #${agency.id}`).toLowerCase().includes(lower)
        );
        setGlobalGridAgencyOptions(filtered);
    };

    const renderGlobalGridFilters = () => {
        if (user.user_type !== SUPER_ADMIN) return null;

        const filterSelectStyle = {
            minWidth: 180,
            maxWidth: 230,
            fontSize: '12px'
        };

        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 8, flexWrap: "wrap" }}>
                <Select
                    mode="multiple"
                    placeholder="Select Carrier"
                    maxTagCount={1}
                    maxTagTextLength={16}
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                    allowClear
                    showSearch
                    className='custom-select agency-select'
                    style={filterSelectStyle}
                    value={gridSelectedCarriers}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => {
                        applyGlobalGridAgencyFilters({
                            selectedCarriers: value,
                            selectedAgencies: [],
                        });
                    }}
                    dropdownRender={(menu) => (
                        <div>
                            <div
                                style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #e8e8e8", fontWeight: 600 }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    const allIds = F.getCarriers().map((carrier) => carrier.id);
                                    const isAllSelected = gridSelectedCarriers.length === allIds.length;
                                    applyGlobalGridAgencyFilters({
                                        selectedCarriers: isAllSelected ? [] : allIds,
                                        selectedAgencies: [],
                                    });
                                }}
                            >
                                <Checkbox
                                    checked={gridSelectedCarriers.length === F.getCarriers().length}
                                    indeterminate={gridSelectedCarriers.length > 0 && gridSelectedCarriers.length < F.getCarriers().length}
                                >
                                    Select All
                                </Checkbox>
                            </div>
                            {menu}
                        </div>
                    )}
                >
                    {F.getCarriers().map((carrier) => (
                        <Option key={carrier.id} value={carrier.id}>{carrier.name}</Option>
                    ))}
                </Select>

                <Select
                    mode="multiple"
                    placeholder="Select Agency Status"
                    maxTagCount={1}
                    maxTagTextLength={16}
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                    allowClear
                    showSearch
                    className='custom-select agency-select'
                    style={{ ...filterSelectStyle, minWidth: 170 }}
                    value={gridSelectedAgencyState.map(String)}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => {
                        applyGlobalGridAgencyFilters({
                            selectedAgencyState: value,
                            selectedAgencies: [],
                        });
                    }}
                    dropdownRender={(menu) => (
                        <div>
                            <div
                                style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #e8e8e8", fontWeight: 600 }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    const allIds = F.getAgenciesState().map((agencyState) => String(agencyState.id));
                                    const isAllSelected = gridSelectedAgencyState.length === allIds.length;
                                    applyGlobalGridAgencyFilters({
                                        selectedAgencyState: isAllSelected ? [] : allIds,
                                        selectedAgencies: [],
                                    });
                                }}
                            >
                                <Checkbox
                                    checked={gridSelectedAgencyState.length === F.getAgenciesState().length}
                                    indeterminate={gridSelectedAgencyState.length > 0 && gridSelectedAgencyState.length < F.getAgenciesState().length}
                                >
                                    Select All
                                </Checkbox>
                            </div>
                            {menu}
                        </div>
                    )}
                >
                    {F.getAgenciesState().map((agencyState) => (
                        <Option key={String(agencyState.id)} value={String(agencyState.id)}>{agencyState.name}</Option>
                    ))}
                </Select>

                <Select
                    mode="multiple"
                    placeholder="Select Agency"
                    maxTagCount={1}
                    maxTagTextLength={16}
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                    allowClear
                    showSearch
                    filterOption={false}
                    className='custom-select agency-select'
                    style={{ ...filterSelectStyle, minWidth: 220 }}
                    value={gridSelectedAgencies}
                    onSearch={searchGlobalGridAgencies}
                    onChange={selectGlobalGridAgencies}
                    dropdownRender={(menu) => (
                        <div>
                            <div
                                style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #e8e8e8", fontWeight: 600 }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    const allIds = globalGridAgencyOptions.map((agency) => agency.id);
                                    const isAllSelected = gridSelectedAgencies.length === allIds.length && allIds.length > 0;
                                    selectGlobalGridAgencies(isAllSelected ? [] : allIds);
                                }}
                            >
                                <Checkbox
                                    checked={gridSelectedAgencies.length === globalGridAgencyOptions.length && globalGridAgencyOptions.length > 0}
                                    indeterminate={gridSelectedAgencies.length > 0 && gridSelectedAgencies.length < globalGridAgencyOptions.length}
                                >
                                    Select All
                                </Checkbox>
                            </div>
                            {menu}
                        </div>
                    )}
                >
                    {globalGridAgencyOptions.map((agencyOption) => (
                        <Option key={agencyOption.id} value={agencyOption.id}>
                            {agencyOption.name || `Agency #${agencyOption.id}`}
                        </Option>
                    ))}
                </Select>
            </div>
        );
    };


    const getAgencyOptionValue = (opt, user) => {
        return user.user_type === AGENCY_MANAGER ? opt.agency_name : opt.name;
    }

    const getAgencyOptionKey = (opt, user) => {
        return user.user_type === AGENCY_MANAGER ? opt.agency_id : opt.id;
    }


    // Update onGridReady to restore column state if present
    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        let excludedCols = ['checkbox'];
        F.handleGridReady(params, setGridApiOptions, excludedCols);
        // Remove columnState logic
    };

    // Handler to save column state on column move
    // const onColumnMoved = useCallback(() => {
    //     if (gridColumnApi) {
    //         setColumnState(gridColumnApi.getColumnState());
    //     }
    // }, [gridColumnApi]);

    // Reapply column state after data reload
    // useEffect(() => {
    //     if (gridColumnApi && columnState) {
    //         gridColumnApi.setColumnState(columnState);
    //     }
    // }, [rowData]);



    const debouncedLoadCalls = useCallback(
        debounce((value, agencySelected) => {
            loadCalls({ pageNumber: 1, selectedAgency: agencySelected, searchByName: value });
        }, 500),
        [page]
    );

    const getCallType = (location) => {
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("call_type");
    };



    // useEffect(() => {
    //     setAMDashboardFilter({
    //         // selectedButton: RSFSCardFilters.selectedButton,
    //         agency_id: fSfilters.selectedAgency,
    //         // selectedFilterOption: RSFSCardFilters.selectedFilterOption,
    //         datemodified: datemodified,
    //     });
    // }, [fSfilters, setFsFilters]);





    useEffect(() => {
        if (!initializedRef.current) return;
        if (searchText.length > 0) {
            setFsFilters({ page: 1 });
            debouncedLoadCalls(searchText);
        }
        else {
            loadCalls({ pageNumber: page })
        }
    }, [searchText, page]);

    const handleSearch = (e) => {
        const value = e.target.value;
        const looksLikePhone = /[\d\(\)\-\s]+$/.test(value);
        const cleanedValue = looksLikePhone ? value.replace(/\D/g, '') : value;
        setFsFilters({ searchText: cleanedValue });
        setSearchText(e.target.value);
    };

    const onSelectionChanged = () => {
        getSelectedRowIds();
    };


    const getSelectedRowIds = () => {
        if (gridApi) {
            const selectedNodes = gridApi.getSelectedNodes();
            const selectedBfiles = selectedNodes.map(node => node.data);
            const selectedIds = selectedNodes.map(node => node.data.id);
            setSelectedBfiles(selectedBfiles);
            setSelectedCheckboxIds(selectedIds);
        } else {
            setSelectedCheckboxIds([]);
        }
    };

    const deleteArchiveBFile = async (action) => {
        if (selectedCheckboxIds.length === 0) return;
        setLoading(true);
        try {
            await Promise.all(
                selectedCheckboxIds.map((bfileId) =>
                    axios.put(`/api/b_file/${bfileId}`, { [action]: 1 })
                )
            );
            setSelectedCheckboxIds([]);
            setFsFilters({ page: 1 });
            setPage(1);
            setCurrentPage(1)
            loadCalls({ pageNumber: 1 });
        } catch (error) {
        } finally {
        }
    };




    const onPageChange = (page) => {
        setFsFilters({ page: page });
        setPage(page);
        loadCalls({ pageNumber: page });
    }


    const handleRoleChange = async (newRole) => {
        setTotalPages(0);
        // getCurrentUserRoles();
        const initialDateRange = {
            start_date: "2010-01-01",
            end_date: "2050-01-01",
        };
        setSelectedAgencyUndefined();
        resetFsFilters();
        setdatemodified(initialDateRange);
        setRowData([]);
        setRSFSCardFilters({
            selectedToggle: newRole,
            selectedToggleAPI: newRole,
            selectedButton: 'AllBFiles'
        });
        setSearchText("");
        setSelectedAgency()
        setSelectedRole("");
        if (newRole === REVIEWSCHEDULER) {
            setShowRoleDropDown(false);
        } else if (newRole === VONBOARDER) {
            setShowRoleDropDown(true)
        }
        await loadCalls();
    };

    const handleRoleChanges = (value) => {
        setFsFilters({
            selectedRole: value
        });
        setSelectedRole(value);

        loadCalls();
    }

    // useEffect(() => {
    //     if (selectedRole) {
    //         loadCalls()
    //     }
    // }, [selectedRole])

    // useEffect(() => {
    //     loadCalls();
    //     setSelectedRole("");
    // }, [RSFSCardFilters.selectedToggle])


    const goToBFileHistory = () => {
        history.push({
            pathname: "/bfiles-history",
            search: location.search.toString(),
        });
    }




    const showSelectionFilterOptionDropdown = () => {
        const zustandState = useBoundStore.getState().RSFSCardFilters;
        let selectedToggleAPI = zustandState.selectedToggleAPI;
        const hasFollowUp = roles.includes("FollowUp");
        const hasProspect = roles.includes("Prospect");
        return selectedToggleAPI === VONBOARDER && hasFollowUp && hasProspect;
    };

    const searchTimeout = useRef(null);

    const [filterKey, setFilterKey] = useState(0);

    // --- Filter popover reset logic ---
    const resetHandlers = useRef([]);
    const handleFilterResetHandler = (resetFn) => {
        resetHandlers.current.push(resetFn);
    };




    return (
        <div>
            {
                user.user_type === VONSCHEDULER && (
                    <CommonHeader user={user} showAvatar={false} onRoleChange={handleRoleChange} />)
            }


            {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {shouldShowHistoryButton(selectedCardType) && (
                    <Button className="bgPrimary" style={{ marginTop: '15px' }}
                        onClick={() => goToBFileHistory()}>
                        B File history
                    </Button>
                )}
            </div> */}

            {/* Right Side: Filters */}
            <div>
                {/* Right Side: Filters */}
                <div
                    className='bfiles-filter-container'
                //  style={{ display: "flex", alignItems: "center", marginTop: "15px", justifyContent: 'flex-end', gap: '10px' }}
                >
                    <div className='left-bfile-filters'>
                        {/*  roles-dropdown */}
                        {showRoleDropDrown && showSelectionFilterOptionDropdown() && (
                            <div style={{ position: 'relative' }}>
                                <Select
                                    allowClear
                                    showSearch
                                    className='dropDown drop_down'
                                    placeholder="Select Role"
                                    optionFilterProp="children"
                                    onChange={handleRoleChanges}
                                    value={selectedRole}
                                // filterOption={(input, option) =>
                                //     option.props.children.toLowerCase().includes(input.toLowerCase())
                                // }
                                // value={selectedFilterOption}

                                >
                                    {filterOptions.map((opt) => (
                                        <Option key={opt.id} value={opt.key}
                                            style={{ fontSize: '12px' }}>
                                            {opt.value}
                                        </Option>
                                    ))}
                                </Select>
                            </div>)}

                        {/* show agency to to FS(all agency) and RS (Dedicated Agency) */}
                        {/* <div>
                                <Select
                                    allowClear
                                    showSearch
                                    className='dropDown drop_down'
                                    placeholder="Search By Agency"
                                    optionFilterProp="children"
                                    onChange={selectAgency}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                    value={selectedAgency}
                                >
                                    {agencies.map((opt) => (
                                        <Option key={opt.id} value={opt.id}
                                            style={{ fontSize: '12px' }}>
                                            {opt.name}
                                        </Option>
                                    ))}
                                </Select>
                                </div> */}

                        {/* Search Input */}
                        <div style={{
                            display: "flex", alignItems: "center",
                            position: "relative",
                            width: '200px'
                        }}>
                            <Input
                                style={{ borderRadius: "28px", paddingRight: "30px" }}
                                placeholder="Search File"
                                value={searchText}
                                onChange={handleSearch}
                            />
                            {searchText ? (
                                <Icon
                                    type="close"
                                    onClick={() => handleSearch({ target: { value: "" } })}

                                    className='icon-style'
                                />
                            ) : (
                                <Icon
                                    type="search"

                                    className='icon-style'
                                />
                            )}
                        </div>

                        {/* Agency Dropdown (only for specific user types) */}
                        {(user.user_type === "EFS" ||
                            user.user_type === REVIEWSCHEDULER || user.user_type === VONSCHEDULER ||
                            user.user_type === VONBOARDER || user.user_type === AGENCY_MANAGER) && (
                                <div style={{ position: 'relative' }}>
                                    <Select
                                        allowClear
                                        className='dropDown drop_down'
                                        showSearch
                                        placeholder="Search By Agency"
                                        optionFilterProp="children"
                                        onChange={selectAgency}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedAgency}
                                    >
                                        {user.user_type === AGENCY_MANAGER && (
                                            <Option value="" style={{ fontSize: "12px" }}>All Agencies</Option>
                                        )}
                                        {agencies.map((opt) => (
                                            <Option key={getAgencyOptionKey(opt, user)}
                                                value={getAgencyOptionKey(opt, user)} style={{ fontSize: "12px" }}>
                                                {getAgencyOptionValue(opt, user)}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            )}


                    </div>

                    <div className='right-bfile-filters'>

                        {/* {(user.user_type === "EFS" ||
                                user.user_type === "REVIEWSCHEDULER" ||
                                user.user_type === "VONBOARDER" || user.user_type === AGENCY_MANAGER) && ( */}

                        {/* ----------Range Picker-------------*/}
                        {/* <div className='datepicker' style={{ marginTop: "-16px", flexDirection: "column" }}>
                            <div className='datepicker-label-rsfs'>Select Date Range</div>

                            <DatePicker.RangePicker
                                className='custom-datepicker'
                                open={open}
                                //// onOpenChange={(status) => setOpen(status)}

                                value={[
                                    datemodified.start_date ? moment(datemodified.start_date) : null,
                                    datemodified.end_date ? moment(datemodified.end_date) : null
                                ]}
                                format={dateFormat}
                                onChange={(dates) => handleRangeChange(dates)}
                                renderExtraFooter={() => (
                                    <div
                                        style={{
                                            textAlign: 'center', cursor: 'pointer',
                                            color: '#1890ff'
                                        }}
                                        onClick={() => {
                                            const today = moment();
                                            handleRangeChange([today, today]);
                                            setOpen(false);
                                        }}
                                    >
                                        Today
                                    </div>
                                )}
                            />
                        </div> */}

                        {/*------- Normal Date Picker -------*/}
                        {/* <div className='datepicker' style={{ marginTop: "-16px", flexDirection: "column" }}>
                            <div className='datepicker-label-rsfs'>Start Date</div>
                            <DatePicker
                                className='custom-datepicker'
                                value={datemodified.start_date
                                    ? moment(datemodified.start_date)
                                    : null}
                                format={dateFormat}
                                onChange={(e) => { handleDateChange(e, 'start_date') }} />
                        </div> */}

                        <Col className='datepicker' style={{ marginTop: "-16px", flexDirection: "column" }}>
                            <div className='datepicker-label' style={{ fontSize: 'x-small' }}>
                                Select Date Range</div>
                            <DatePicker.RangePicker
                                dropdownClassName="custom-range-picker" //for header
                                open={open}
                                // onOpenChange={(status) => setOpen(status)}
                                onOpenChange={(status) => {
                                    if (!status) return;
                                    setOpen(true);
                                }}
                                value={[
                                    datemodified.start_date ? moment(datemodified.start_date) : null,
                                    datemodified.end_date ? moment(datemodified.end_date) : null
                                ]}
                                format={dateFormat}
                                onChange={(dates) => {
                                    if (dates && dates.length === 2) {
                                        const start = dates[0].format("YYYY-MM-DD");
                                        const end = dates[1].format("YYYY-MM-DD");
                                        setdatemodified(prev => ({
                                            ...prev,
                                            start_date: start,
                                            end_date: end
                                        }));
                                        setOpen(true);
                                    }
                                }}
                                renderExtraFooter={() => {
                                    const start = datemodified.start_date
                                        ? moment(datemodified.start_date)
                                        : moment();

                                    const end = datemodified.end_date
                                        ? moment(datemodified.end_date)
                                        : moment();

                                    return (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between', gap: 20
                                        }}>

                                            {/* START CONTROLS */}
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                                <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                                                <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                                                    <Select
                                                        showSearch
                                                        value={start.month()}
                                                        style={{ width: 100 }}
                                                        // className="dateRangedropDown custom-select"
                                                        onChange={(month) => {
                                                            const newDate = start.clone().month(month);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                start_date: newDate,
                                                            }));
                                                            setFsFilters({
                                                                datemodified: {
                                                                    start_date: newDate
                                                                },
                                                                page: 1
                                                            });
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getMonthNames().map((m, i) => (
                                                            <Option key={i} value={i}>{m}</Option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        showSearch
                                                        value={start.year()}
                                                        // className="dateRangedropDown custom-select"
                                                        style={{ width: 80 }}
                                                        onChange={(year) => {
                                                            const newDate = start.clone().year(year);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                start_date: newDate,
                                                            }));
                                                            setFsFilters({
                                                                datemodified: {
                                                                    start_date: newDate
                                                                },
                                                                page: 1
                                                            });
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getYears().map((y) => (
                                                            <Option key={y} value={y}>{y}</Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>

                                            {/* END CONTROLS */}
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                                <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                                                <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                                                    <Select
                                                        showSearch
                                                        value={end.month()}
                                                        style={{ width: 100 }}
                                                        // className="dateRangedropDown custom-select"
                                                        onChange={(month) => {
                                                            const newDate = end.clone().month(month);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                end_date: newDate,
                                                            }));
                                                            setFsFilters({
                                                                datemodified: {
                                                                    end_date: newDate
                                                                },
                                                                page: 1
                                                            });
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getMomentMonths().map((m, i) => (
                                                            <Option key={i} value={i}>{m}</Option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        showSearch
                                                        value={end.year()}
                                                        style={{ width: 80 }}
                                                        // className="dateRangedropDown custom-select"
                                                        onChange={(year) => {
                                                            const newDate = end.clone().year(year);
                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                end_date: newDate,
                                                            }));
                                                            setFsFilters({
                                                                datemodified: {
                                                                    end_date: newDate
                                                                },
                                                                page: 1
                                                            });
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children &&
                                                            option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {F.getYears().map((y) => (
                                                            <Option key={y} value={y}>{y}</Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>

                                            {/* TODAY BUTTON */}
                                            <div
                                                style={{
                                                    alignSelf: 'center', cursor: 'pointer',
                                                    color: '#1890ff',
                                                    marginTop: '10px'
                                                }}
                                                onClick={() => {
                                                    const today = moment().format("YYYY-MM-DD");

                                                    setdatemodified(prev => ({
                                                        ...prev,
                                                        start_date: today,
                                                        end_date: today
                                                    }));

                                                    setFsFilters({
                                                        datemodified: {
                                                            start_date: today,
                                                            end_date: today
                                                        },
                                                        page: 1
                                                    });

                                                    // setOpen(false);
                                                }}
                                            >
                                                Today
                                            </div>

                                            {/* VIEW BUTTON */}

                                            <div
                                                style={{
                                                    alignSelf: 'center'
                                                }}>
                                                <Button type="primary"
                                                    className="borderRadius-28 bg-164897"
                                                    style={{ marginTop: '15px' }}
                                                    onClick={() => {
                                                        const appliedStartDate = datemodified.start_date
                                                            ? moment(datemodified.start_date).format("YYYY-MM-DD")
                                                            : null;
                                                        const appliedEndDate = datemodified.end_date
                                                            ? moment(datemodified.end_date).format("YYYY-MM-DD")
                                                            : null;

                                                        setdatemodified(prev => ({
                                                            ...prev,
                                                            start_date: appliedStartDate,
                                                            end_date: appliedEndDate,
                                                        }));


                                                        setFsFilters({
                                                            datemodified: {
                                                                start_date: appliedStartDate,
                                                                end_date: appliedEndDate,
                                                            },
                                                            page: 1
                                                        });

                                                        if (user.user_type === SUPER_ADMIN) {
                                                            useBoundStore.getState().setGlobalDashboardFilter({
                                                                datemodified: {
                                                                    start_date: appliedStartDate,
                                                                    end_date: appliedEndDate,
                                                                },
                                                                page: 1,
                                                                isDateRangeClicked: true
                                                            });
                                                        } else {
                                                            setAMDashboardFilter({
                                                                datemodified: {
                                                                    start_date: appliedStartDate,
                                                                    end_date: appliedEndDate,
                                                                },
                                                                isDateRangeClicked: true
                                                            });
                                                        }

                                                        loadCalls();

                                                        setOpen(false);
                                                    }}
                                                >
                                                    <Translate text={"Apply"}></Translate>
                                                </Button>
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                        </Col>


                        {/* <div className='datepicker' style={{ marginTop: "-16px", flexDirection: "column" }} >
                            <div className='datepicker-label-rsfs'>End Date</div>
                            <DatePicker
                                value={datemodified.end_date
                                    ? moment(datemodified.end_date)
                                    : null}
                                format={dateFormat}
                                onChange={(e) => { handleDateChange(e, "end_date") }} />
                        </div> */}


                        {/* <div>
                            <Button className="refreshBtnCss" onClick={exportExcel}>
                                <Icon type="export"
                                    style={{ marginRight: user_type !== AGENCY_MANAGER ? "8px" : "0px" }} />
                                {
                                    (
                                        user_type != AGENCY_MANAGER && (
                                            <Translate text="Export Excel" />
                                        )
                                    )
                                }
                            </Button>
                        </div> */}

                        <div>

                            {/* Refresh Button */}
                            <Button className="refreshBtnCss" onClick={refresh}>
                                <Icon type="reload"
                                    style={{ marginRight: user_type !== AGENCY_MANAGER ? "8px" : "0px" }} />
                                {
                                    (
                                        user_type != AGENCY_MANAGER && (
                                            <Translate text="Refresh" />
                                        )
                                    )
                                }
                            </Button>
                        </div>
                        {shouldShowHistoryButton(selectedCardType) && (
                            <Button className="bgPrimary"
                                onClick={() => goToBFileHistory()}>
                                B File history
                            </Button>
                        )}

                    </div>





                    {/* )} */}



                </div>
            </div>

            <Card
                type="inner"
                style={{ background: "#FAFAFA" }}
                title={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", gap: 12, flexWrap: "wrap" }}>
                        {/* Left Side: Folder Icon & Title */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Icon type="folder" style={{ marginRight: 10, color: "#1890ff" }} />
                            <Translate text={title} />
                        </div>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 8, flex: 1, flexWrap: "wrap" }}>
                            {renderGlobalGridFilters()}
                            {
                                // (title === BAD_PHONE_NUMBER) &&
                                (user.user_type === EA || user.user_type === LSP) && (
                                    <Button
                                        type="primary"
                                        className='refreshBtnCss'
                                        onClick={handleExportExcel}
                                    >
                                        <Icon type="upload" style={{ marginRight: '10px' }} />
                                        <Translate text={EXPORT_DATA} />

                                    </Button>
                                )}
                        </div>
                    </div>
                }
                className="tableCard p_and_c_card"
            >


                {/* Align buttons to the LEFT */}
                <Row style={{ display: "flex", justifyContent: "flex-start", marginTop: "15px", marginBottom: "15px", marginLeft: "20px" }}>
                    {selectedCheckboxIds.length > 0 &&
                        (user.user_type === "EA" || user.user_type === "LSP") && (
                            <Col style={{ display: "flex", gap: "10px" }}>
                                <Button type="default" className="buttoncss"
                                    style={{
                                        border: '1px solid red'
                                    }}
                                    onClick={() => deleteArchiveBFile('deleted')}>
                                    <Icon type="delete" style={{ marginRight: '8px', color: "red" }} />
                                    <span style={{ color: "red" }}>
                                        <Translate text="Delete B File" />
                                    </span>
                                </Button>


                                <Button type="default" className='buttoncss'
                                    style={{
                                        border: '1px solid #1890ff'
                                    }}
                                    onClick={openChangeCreatorModal}>
                                    <Icon type="edit" style={{ marginRight: '8px', color: "#1890ff" }} />
                                    <span style={{ color: "#1890ff" }}>
                                        <Translate text="Change Creator" />
                                    </span>

                                </Button>
                            </Col>
                        )}


                    {/* Change Creator BFile Modal */}
                    {isChangeCreatorModalOpen && (<ChangeCreator
                        history={history}
                        showModal={isChangeCreatorModalOpen}
                        hideModal={closeChangeCreatorModal}
                        bfiles={selectedBfiles}
                        user={user}
                        done={() => {
                            closeChangeCreatorModal();
                            loadCalls({ pageNumber: page });
                        }}
                    />
                    )}
                </Row>


                <div style={{ position: 'relative' }}>
                    <CustomAgGridTable
                        rowDatas={rowData}
                        columnDefss={columnDefs}
                        onGridReady={onGridReady}
                        onSelectionChanged={onSelectionChanged}
                        rowSelection="multiple"
                    />
                    {loading && (
                        <div style={{
                            position: 'absolute',
                            top: 0, left: 0, right: 0, bottom: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10
                        }}>
                            <Spin tip="Loading ..." />
                        </div>
                    )}
                </div>
                <div style={{ float: "right", marginTop: "20px", marginBottom: "20px" }}>
                    <Pagination
                        current={currentPage}
                        total={totalPages * pageSize}
                        pageSize={pageSize}
                        showSizeChanger={false}
                        onChange={(page) => onPageChange(page)}
                    />
                </div>
            </Card>

        </div>
    );
};

export default CallPageNew;



// WEBPACK FOOTER //
// ./src/scenes/CallPage/indexNew.js